import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { adminPost, valiadteEmail, valiadteNumber } from "../../redux/Authentication/AuthSlice";
import { createEmployee } from "../../redux/Employee/employeeSlice";
import { FileUploader } from "react-drag-drop-files";
import { CaseActions, UploadChasisImage, UploadFrontImage, UploadOpenBonnet, UploadRearUnderPart, UploadRight45Image, createCase, selfieWithVehicle, selfieWithVehicleUpload, sendVehicleNumber, uploadAnyDamage, uploadExtraImage, uploadExtraImage1, uploadExtraImage2, uploadExtraImage3, uploadFrontUnderCar, uploadGlassInsideImage, uploadGlassOutside, uploadLeft45, uploadLeftImage, uploadOdometerImage, uploadOpenDickey, uploadRcBackImage, uploadRcFront, uploadRearImage, uploadRightImage, uploadRpmImage, uploadSignature, uploadTyreImage, uploadformatImage } from "../../redux/Cases/CaseSlice";
import { useNavigate, useParams } from "react-router-dom";
import { Baseurl } from "../../config/BaseUrl";
import axios from "axios";
import Spinner from 'react-bootstrap/Spinner';
import FourWheelerEditReport4 from "../Reports/FourWheelerEditReport4";

const AddCommercialCase = () => {
    const dispatch = useDispatch();
    const params = useParams();
    const navigate=useNavigate()
    const { selfieWithVehicleImage, isSelfieWithAgentLoading, chasisImage, isChasisImageLoading,
        IsformatImageLoading,
        formatImage,
        isOpenBonnetLoading,
        openBonnet,
        isRight45ImageLoading,
        right45image,
        frontimage,
        isFrontImageLoading,
        frontUnderCarImage,
        isFrontUnderCarImageLoading,
        isLeft45Loading,
        left45image,
        isLeftImageLoading,
        leftImage,
        rearImage,
        isRearImageLoading,
        rearUnderPartImage,
        isRearUnderPartLoading,
        openDickeyImage,
        isOpenDickeyImageLoading,
        rightImage,
        isRightImageLoading,
        tyreImage,
        isTyreImageLoading,
        glassOutsideImage,
        isGlassOutsideImageLoading,
        glassInsideImage,
        isGlassInsideImageLoading,
        odometerImage,
        isOdometerImageLoading,
        rpmImage,
        isRpmImageLoading,
        anyDamage,
        isAnyDamageLoading,
        extraImage,
        isExtraImageLoading,
        extraImage1,
        isExtraImage1Loading,
        extraImage2,
        isExtraImage2Loading,
        extraImage3,
        isExtraImage3Loading,
        signatureImage,
        isSignatureImageLoading,
        rcFrontImage,
        isRcFrontImageLoading,
        rcBackImage,
        isRcBackImageLoading
    } = useSelector((store) => store.cases)
    const [assetType, setAssetType] = useState("");
    const [assetTypeError, setAssetTypeError] = useState("");
    const [caseType, setCaseType] = useState("");
    const [caseTypeError, setCaseTypeError] = useState("");
    const [valuationPurpose, setValuationPurpose] = useState('Assesment of fair market value');
    const [valuationPurposeError, setValuationPurposeError] = useState('');
    const [requesterName, setRequesterName] = useState("");
    const [requesterNameError, setRequesterNameError] = useState("");
    const [requesterBranch, setRequesterBranch] = useState("");
    const [requesterBranchError, setRequesterBranchError] = useState("");
    const [requesterPhone, setRequesterPhone] = useState("");
    const [requesterPhoneError, setRequesterPhoneError] = useState("");
    const [email, setEmail] = useState("");
    const [Cnfemail, setCnfEmail] = useState("");
    const [emailError, setEmailError] = useState("");
    const [mobile, setMobile] = useState("");
    const [mobileCnf, setMobileCnf] = useState("");
    const [mobileError, setMobileError] = useState("");
    const [name, setName] = useState("");
    const [nameError, setNameError] = useState("");
    const [address, setAddress] = useState("")
    const [addressError, setAddressError] = useState("")
    const [state, setState] = useState("")
    const [stateError, setStateError] = useState("")
    const [cityList, setCityList] = useState([]);
    const [city, setCity] = useState("")
    const [cityError, setCityError] = useState("")
    const [productType, setProductType] = useState("")
    const [productTypeError, setProductTypeError] = useState("")
    const [productBrand, setProductBrand] = useState("")
    const [productBrandError, setProductBrandError] = useState("")
    const [vehicleLocation, setVehicleLocation] = useState('')
    const [vehicleLocationError, setVehicleLocationError] = useState('')
    const [model, setModel] = useState("")
    const [ModelError, setModelError] = useState("")
    const [variant, setVariant] = useState("")
    const [variantError, setVariantError] = useState("")
    const [loanNo, setLoanNo] = useState("")
    const [loanNoError, setLoanNoError] = useState("")
    const [docVerified, setDocVerified] = useState('');
    const [regdOwner, setRegdOwner] = useState("")
    const [regdOwnerError, setRegdOwnerError] = useState("")
    const [regdDate, setRegdDate] = useState("")
    const [regdDateError, setRegdDateError] = useState("")
    const [mfgDate, setMfgdate] = useState('');
    const [numberPlateType, setNumberPlateType] = useState('');
    const [regdNo, setRegdNo] = useState("")
    const [regdNoError, setRegdNoError] = useState("")
    const [vehicleData, setVehicleData] = useState({});
    const [dataFetched, setDataFetched] = useState(false)
    const [engNo, setEngNo] = useState("")
    const [engNoError, setEngNoError] = useState("")
    const [chasisNo, setChasisNo] = useState("")
    const [chasisNoError, setChasisNoError] = useState("")
    const [bodyType, setBodyType] = useState("")
    const [bodyTypeError, setBodyTypeError] = useState("")
    const [meterReading, setMeterReading] = useState('');
    const [fueltype, setFueltype] = useState("")
    const [fueltypeError, setFueltypeError] = useState("")
    const [vehicleColor, setVehicleColor] = useState("")
    const [vehicleColorError, setVehicleColorError] = useState("")
    const [ownerSerialNo, setOwnerSerialNo] = useState("")
    const [ownerSerialNoError, setOwnerSerialNoError] = useState("")
    const [hypothecationBank, setHypothecationBank] = useState("")
    const [hypothecationBankError, setHypothecationBankError] = useState("")
    const [insuranceCompany, setInsuranceCompany] = useState('');
    const [insuranceStatus, setInsuranceStatus] = useState('');
    const [cubicCapacity, setCubicCapacity] = useState("")
    const [cubicCapacityError, setCubicCapacityError] = useState("")
    const [seatingCapacity, setSeatingCapacity] = useState("")
    const [eatingCapacityError, setSeatingCapacityError] = useState("")
    const [vehicleWeight, setVehicleWeight] = useState("")
    const [vehicleWeightError, setVehicleWeightError] = useState("")

    const [selectedVideo, setSelectedVideo] = useState(null);
    const [showLoader, setShowLoader] = useState(false)
    const [videoRecord, setVideoRecord] = useState('')

    const [role, setRole] = useState("")
    const fileTypes = ["JPG", "PNG", "GIF"];

    const [airConditioner, setAirConditioner] = useState("");
    const [cdCharge, setCdCharge] = useState("");
    const [seatCover, setSeatCover] = useState("");
    const [fogLamps, setFogLamps] = useState("");
    const [transmission, setTransmission] = useState("");
    const [odometer, setOdometer] = useState("");
    const [accidental, setAccidental] = useState("");
    const [otherRepair, setotherRepair] = useState("");
    const [fitnessExpiry, setFitnessExpiry] = useState("");
    const [roadtaxValidity, setroadtaxValidity] = useState("");
    const [idvValue, setIdvValue] = useState("");
    const [insuranceExpiry, setInsuranceExpiry] = useState("");
    const [engineCondition, setEngineCondition] = useState("");
    const [engineConditionError, setEngineConditionError] = useState("");
    const [wheelType, setWheelType] = useState("");
    const [totalTyre, setTotalTyre] = useState("");
    const [availableTyre, setAvailableTyre] = useState("");
    const [missingTyre, setMissingTyre] = useState("");
    const [spareTyre, setSpareTyre] = useState("");
    const [interiorCondition, setInteriorCondition] = useState("");
    const [interiorConditionError, setInteriorConditionError] = useState("");
    const [exteriorCondition, setExteriorCondition] = useState("");
    const [exteriorConditionError, setExteriorConditionError] = useState("");
    const [headLamp, setHeadLamp] = useState("");
    const [tailLamp, setTailLamp] = useState("");
    const [frontIndicators, setFrontIndicators] = useState("");
    const [rearIndicators, setRearIndicators] = useState("");
    const [maintenanceLevel, setMaintenanceLevel] = useState("");
    const [frontBrakeCondition, setFrontBreakCondition] = useState("");
    const [frontBrakeConditionError, setFrontBreakConditionError] = useState("");
    const [rearBrakeCondition, setRearBreakCondition] = useState("");
    const [rearBrakeConditionError, setRearBreakConditionError] = useState("");
    const [comFrontCrashGuard, setComFrontCrashGuard] = useState("");
    const [comLoadCarrier, setComLoadCarrier] = useState("");
    const [comMusicSystem, setComMusicSystem] = useState("");
    const [comRearUnderRun, setComRearUnderRun] = useState("");
    const [comSideUnderRun, setComSideUnderRun] = useState("");
    const [comToolkit, setComToolkit] = useState("");
    const [comTvVideo, setComTvVideo] = useState("");
    const [comBodyCondition, setComBodyCondition] = useState("");
    const [comHandBrake, setComHandBrake] = useState("");
    const [comDoorCondition, setComDoorCondition] = useState("");
    const [comSideGlassesCondition, setComSideGlassesCondition] = useState("");
    const [comWindscreenCondition, setComWindscreenCondition] = useState("");
    const [comBatteryCondition, setComBatteryCondition] = useState("");
    const [comClusterUnitCondition, setComClusterUnitCondition] = useState("");
    const [comFogLampStatus, setComFogLampStatus] = useState("");
    const [comBatteryNo, setComBatteryNo] = useState("");
    const [comWiperStatus, setComWiperStatus] = useState("");
    const [comEngineStatus, setComEngineStatus] = useState("");
    const [comEngineShieldCondition, setComEngineShieldCondition] = useState("");
    const [comFluidLeakStatus, setComFluidLeakStatus] = useState("");
    const [comSuspensionCondition, setComSuspensionCondition] = useState("");
    const [comSuspensionConditionError, setComSuspensionConditionError] = useState("");
    const [comTransmissionCondition, setComTransmissionCondition] = useState("");
    const [comTransmissionConditionError, setComTransmissionConditionError] = useState("");
    const [comAxleOneLeftIn, setComAxleOneLeftIn] = useState("");
    const [comAxleOneLeftOut, setComAxleOneLeftOut] = useState("");
    const [comAxleOneRightIn, setComAxleOneRightIn] = useState("");
    const [comAxleOneRightOut, setComAxleOneRightOut] = useState("");
    const [comAxleThreeLeftIn, setComAxleThreeLeftIn] = useState("");
    const [comAxleThreeLeftOut, setComAxleThreeLeftOut] = useState("");
    const [comAxleThreeRightIn, setComAxleThreeRightIn] = useState("");
    const [comAxleThreeRightOut, setComAxleThreeRightOut] = useState("");
    const [comAxleTwoLeftIn, setComAxleTwoLeftIn] = useState("");
    const [comAxleTwoLeftOut, setComAxleTwoLeftOut] = useState("");
    const [comAxleTwoRightIn, setComAxleTwoRightIn] = useState("");
    const [comAxleTwoRightOut, setComAxleTwoRightOut] = useState("");
    const [comFrontOneLeft, setComFrontOneLeft] = useState("");
    const [comFrontOneRight, setComFrontOneRight] = useState("");
    const [comFrontTwoLeft, setComFrontTwoLeft] = useState("");
    const [comFrontTwoRight, setComFrontTwoRight] = useState("");
    const [comFrontTruckTyreCondition, setComFrontTruckTyreCondition] =
        useState("");
    const [comFrontTruckTyreConditionError, setComFrontTruckTyreConditionError] =
        useState("");
    const [comFrontTruckTyreType, setComFrontTruckTyreType] = useState("");
    const [comAxleCondition, setComAxleCondition] = useState("");

    const [yourRemark, setYourRemark] = useState("");
    const [exShowRoomPrice, setExShowRoomPrice] = useState("");
    const [exShowRoomPriceError, setExShowRoomPriceError] = useState("");
    const [estimatedPrice, setEstimatedPrice] = useState("");
    const [estimatedPriceError, setEstimatedPriceError] = useState("");

    const selectCaseType = [
        {
            id: 1,
            name: "Revaluation",
        },
        {
            id: 2,
            name: "Repossession",
        },
        {
            id: 3,
            name: "Retail",
        },
        {
            id: 4,
            name: "Insurance Idv",
        },
        {
            id: 5,
            name: "Repurchase",
        },
    ];
    const selectCaseChange = (e) => {
        const { value } = e.target;
        const index = e.nativeEvent.target.selectedIndex;
        const text = e.nativeEvent.target[index].text;
        setCaseType(text);
    };
    const selectAssetType = [
        {
            id: 1,
            name: "Two Wheeler",
        },
        {
            id: 2,
            name: "Four Wheeler",
        },
        {
            id: 3,
            name: "Commercial",
        },
        {
            id: 4,
            name: "Construction Equipment",
        },
        {
            id: 5,
            name: "Three Wheeler",
        },
        {
            id: 6,
            name: "Farm Equipment",
        },
    ];
    const selectAssetChange = (e) => {
        const { value } = e.target;
        const index = e.nativeEvent.target.selectedIndex;
        const text = e.nativeEvent.target[index].text;
        setAssetType(text);
    };

    const handleRequesterPhn = async (e) => {
        const value = e.target.value.replace(/\D/g, "");
        setRequesterPhone(value)
    }

    const stateList = [
        { id: 1, name: "Andhra Pradesh" },
        { id: 2, name: "Arunachal Pradesh" },
        { id: 3, name: "Assam" },
        { id: 4, name: "Bihar" },
        { id: 5, name: "Chhattisgarh" },
        { id: 6, name: "Goa" },
        { id: 7, name: "Gujarat" },
        { id: 8, name: "Haryana" },
        { id: 9, name: "Himachal Pradesh" },
        { id: 10, name: "Jharkhand" },
        { id: 11, name: "Karnataka" },
        { id: 12, name: "Kerala" },
        { id: 13, name: "Madhya Pradesh" },
        { id: 14, name: "Maharashtra" },
        { id: 15, name: "Manipur" },
        { id: 16, name: "Meghalaya" },
        { id: 17, name: "Mizoram" },
        { id: 18, name: "Nagaland" },
        { id: 19, name: "Odisha" },
        { id: 20, name: "Punjab" },
        { id: 21, name: "Rajasthan" },
        { id: 22, name: "Sikkim" },
        { id: 23, name: "Tamil Nadu" },
        { id: 24, name: "Telangana" },
        { id: 25, name: "Tripura" },
        { id: 26, name: "Uttar Pradesh" },
        { id: 27, name: "Uttarakhand" },
        { id: 28, name: "West Bengal" },
        { id: 29, name: "Andaman and Nicobar Islands" },
        { id: 30, name: "Chandigarh" },
        { id: 31, name: "Dadra and Nagar Haveli and Daman and Diu" },
        { id: 32, name: "Delhi" },
        { id: 33, name: "Ladakh" },
        { id: 34, name: "Lakshadweep" },
        { id: 35, name: "Puducherry" }
    ];
    const selectStateChange = (e) => {
        const { value } = e.target;
        const index = e.nativeEvent.target.selectedIndex;
        const text = e.nativeEvent.target[index].text;
        setState(text);
    };
    useEffect(() => {
        if (state) {
            const formData = {
                country: 'India',
                state: state.toLocaleUpperCase(),
            };
            const getCity = async () => {
                try {
                    const config = {
                        headers: { 'Content-Type': 'application/json' },
                    };
                    const url = 'https://countriesnow.space/api/v0.1/countries/state/cities';
                    const resp = await axios.post(url, formData, config);
                    if (!resp.data.error) {
                        const citiesData = resp.data.data.map((city, index) => ({
                            id: index + 1,
                            name: city.toLowerCase().replace(/\s/g, '_'),
                        }));
                        setCityList(citiesData);
                    } else {
                        console.error("Error in response:", resp.data.error); // Log the error for debugging
                    }
                } catch (error) {
                    console.error("Error:", error); // Log any other errors for debugging
                }
            };

            getCity();
        }
    }, [state]);

    const selectCityChange = (e) => {
        const { value } = e.target;
        const index = e.nativeEvent.target.selectedIndex;
        const text = e.nativeEvent.target[index].text;
        setCity(text);
    };

    const handleRegdNo = async (e) => {
        const inputValue = e.target.value.toUpperCase();
        setRegdNo(inputValue);
        setDataFetched(false); // Reset data fetched status

        if (inputValue.length === 9 || inputValue.length === 10) {
            try {
                // let newData = await fetchVehicleData(inputValue);
                const formData = {
                    "regdNo": inputValue,
                }
                const vehicle = await dispatch(sendVehicleNumber(formData))
                setVehicleData(vehicle.payload.response.result);
                setDataFetched(true);
            } catch (error) {
                setVehicleData(null); // Reset vehicle data
            }
        } else {
            setVehicleData(null); // Reset vehicle data if input length is invalid
        }
    };

    useEffect(() => {
        // Fetch data again if required properties are null after initial fetch
        if (dataFetched && vehicleData) {
            const {
                rcFinancer,
                vehicleTaxUpto,
                permitValidUpto,
                permitType,
                vehicleSeatCapacity,
                grossVehicleWeight,
                regAuthority
            } = vehicleData;

            if (
                !rcFinancer ||
                !vehicleTaxUpto ||
                !permitValidUpto ||
                !permitType ||
                !vehicleSeatCapacity ||
                !grossVehicleWeight ||
                !regAuthority
            ) {
                // Required properties are still null, fetch again
                handleRegdNo({ target: { value: regdNo } });
            }
        }
    }, [dataFetched, vehicleData, regdNo]);

    const documents = [
        { name: 'Verified', id: 1 },
        { name: 'Not Verified', id: 2 },
    ];
    const selectDocuementVerifiedTypeChange = (e) => {
        const { value } = e.target;
        const index = e.nativeEvent.target.selectedIndex;
        const text = e.nativeEvent.target[index].text;
        setDocVerified(text);
    };
    const number = [
        { name: 'White', id: 1 },
        { name: 'Yellow', id: 2 },
        { name: 'Blue', id: 3 },
        { name: 'Black', id: 4 },
    ];
    const selectNumberPlateTypeChange = (e) => {
        const { value } = e.target;
        const index = e.nativeEvent.target.selectedIndex;
        const text = e.nativeEvent.target[index].text;
        setNumberPlateType(text);
    };
    const options = [
        { name: 'Yes', id: 1 },
        { name: 'No', id: 2 },
    ];
    const Features = [
        { name: "2WD", id: 1 },
        { name: "Manual", id: 2 },
        { name: "Normal", id: 3 },
    ];
    const condition = [
        { name: "Poor", id: 1 },
        { name: "Average", id: 2 },
        { name: "Satisfactory", id: 3 },
        { name: "Good", id: 4 },
        { name: "Excellent", id: 5 },
        { name: "NA", id: 6 },
    ];
    const reqCondition = [
        { name: "Poor", id: 1 },
        { name: "Average", id: 2 },
        { name: "Satisfactory", id: 3 },
        { name: "Good", id: 4 },
        { name: "Excellent", id: 5 }
    ];
    const list = [
        { name: "10", id: 1 },
        { name: "20", id: 2 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 },
        { name: "60", id: 6 },
        { name: "70", id: 7 },
        { name: "80", id: 8 },
        { name: "90", id: 9 },
        { name: "100", id: 10 },
    ];
    const qualityList = [
        { name: "Original", id: 1 },
        { name: "Replaced", id: 2 },
    ];
    const wheelTypeList = [
        { name: "Alloy", id: 1 },
        { name: "Steel", value: 2 },
        { name: "Rim", value: 3 },
    ];


    const selectInsuranceStatusChange = (e) => {
        const { value } = e.target;
        const index = e.nativeEvent.target.selectedIndex;
        const text = e.nativeEvent.target[index].text;
        setInsuranceStatus(text);
    };

    const handleFileChange = (event) => {
        setSelectedVideo(event.target.files[0])
    };

    const handleUpload = async () => {
        setShowLoader(true)
        const apiKey = '918618947122224';
        const cloudName = 'dexterous-technology';
        const uploadPreset = 'yrevfjck';
        if (selectedVideo) {
            const formData = new FormData();
            formData.append('file', selectedVideo);
            formData.append('upload_preset', 'yrevfjck'); // Replace 'your_upload_preset' with your Cloudinary upload preset

            try {
                const response = await fetch(`https://api.cloudinary.com/v1_1/${cloudName}/video/upload`, {
                    method: 'POST',
                    body: formData
                });

                if (response.ok) {
                    const responseData = await response.json();
                    setVideoRecord(responseData.secure_url)
                    document.getElementById('videouploading').value = '';
                    setShowLoader(false)
                } else {
                    // Handle upload failure
                    console.error('Failed to upload video to Cloudinary:', response.statusText);
                }
            } catch (error) {
                // Handle network or server errors
                console.error('Error uploading video to Cloudinary:', error);
            }
        } else {
            console.log("No video selected.");
        }
    };

    const handleSelfieWithVehicleChange = async (e) => {
        const files = Array.from(e.target.files);
        files.forEach((file) => {
            const reader = new FileReader();
            reader.onload = () => {
                if (reader.readyState === 2) {
                    dispatch(selfieWithVehicleUpload({ image: reader.result }));
                }
            };
            reader.readAsDataURL(file);
        });
    };
    const handleChasisChange = async (e) => {
        const files = Array.from(e.target.files);
        files.forEach((file) => {
            const reader = new FileReader();
            reader.onload = () => {
                if (reader.readyState === 2) {
                    dispatch(UploadChasisImage({ image: reader.result }));
                }
            };
            reader.readAsDataURL(file);
        });
    };
    const handleFormatChange = async (e) => {
        const files = Array.from(e.target.files);
        files.forEach((file) => {
            const reader = new FileReader();
            reader.onload = () => {
                if (reader.readyState === 2) {
                    dispatch(uploadformatImage({ image: reader.result }));
                }
            };
            reader.readAsDataURL(file);
        });
    };
    const handleOpenBonnetChange = async (e) => {
        const files = Array.from(e.target.files);
        files.forEach((file) => {
            const reader = new FileReader();
            reader.onload = () => {
                if (reader.readyState === 2) {
                    dispatch(UploadOpenBonnet({ image: reader.result }));
                }
            };
            reader.readAsDataURL(file);
        });
    };
    const handleright45Change = async (e) => {
        const files = Array.from(e.target.files);
        files.forEach((file) => {
            const reader = new FileReader();
            reader.onload = () => {
                if (reader.readyState === 2) {
                    dispatch(UploadRight45Image({ image: reader.result }));
                }
            };
            reader.readAsDataURL(file);
        });
    };
    const frontImage = async (e) => {
        const files = Array.from(e.target.files);
        files.forEach((file) => {
            const reader = new FileReader();
            reader.onload = () => {
                if (reader.readyState === 2) {
                    dispatch(UploadFrontImage({ image: reader.result }));
                }
            };
            reader.readAsDataURL(file);
        });
    };
    const frontUnderCarImg = async (e) => {
        const files = Array.from(e.target.files);
        files.forEach((file) => {
            const reader = new FileReader();
            reader.onload = () => {
                if (reader.readyState === 2) {
                    dispatch(uploadFrontUnderCar({ image: reader.result }));
                }
            };
            reader.readAsDataURL(file);
        });
    };
    const handlesetLeft45Image = async (e) => {
        const files = Array.from(e.target.files);
        files.forEach((file) => {
            const reader = new FileReader();
            reader.onload = () => {
                if (reader.readyState === 2) {
                    dispatch(uploadLeft45({ image: reader.result }));
                }
            };
            reader.readAsDataURL(file);
        });
    };
    const handlesetLeftImage = async (e) => {
        const files = Array.from(e.target.files);
        files.forEach((file) => {
            const reader = new FileReader();
            reader.onload = () => {
                if (reader.readyState === 2) {
                    dispatch(uploadLeftImage({ image: reader.result }));
                }
            };
            reader.readAsDataURL(file);
        });
    };
    const handlesetRearImage = async (e) => {
        const files = Array.from(e.target.files);
        files.forEach((file) => {
            const reader = new FileReader();
            reader.onload = () => {
                if (reader.readyState === 2) {
                    dispatch(uploadRearImage({ image: reader.result }));
                }
            };
            reader.readAsDataURL(file);
        });
    };
    const handlerearUnderPartImage = async (e) => {
        const files = Array.from(e.target.files);
        files.forEach((file) => {
            const reader = new FileReader();
            reader.onload = () => {
                if (reader.readyState === 2) {
                    dispatch(UploadRearUnderPart({ image: reader.result }));
                }
            };
            reader.readAsDataURL(file);
        });
    };
    const handlerearOpenDickeyImage = async (e) => {
        const files = Array.from(e.target.files);
        files.forEach((file) => {
            const reader = new FileReader();
            reader.onload = () => {
                if (reader.readyState === 2) {
                    dispatch(uploadOpenDickey({ image: reader.result }));
                }
            };
            reader.readAsDataURL(file);
        });
    };
    const HandlerightImage = async (e) => {
        const files = Array.from(e.target.files);
        files.forEach((file) => {
            const reader = new FileReader();
            reader.onload = () => {
                if (reader.readyState === 2) {
                    dispatch(uploadRightImage({ image: reader.result }));
                }
            };
            reader.readAsDataURL(file);
        });
    };
    const handlesetTyreImage = async (e) => {
        const files = Array.from(e.target.files);
        files.forEach((file) => {
            const reader = new FileReader();
            reader.onload = () => {
                if (reader.readyState === 2) {
                    dispatch(uploadTyreImage({ image: reader.result }));
                }
            };
            reader.readAsDataURL(file);
        });
    };
    const handleGlassOutsideImage = async (e) => {
        const files = Array.from(e.target.files);
        files.forEach((file) => {
            const reader = new FileReader();
            reader.onload = () => {
                if (reader.readyState === 2) {
                    dispatch(uploadGlassOutside({ image: reader.result }));
                }
            };
            reader.readAsDataURL(file);
        });
    };
    const handleGlassInsideImage = async (e) => {
        const files = Array.from(e.target.files);
        files.forEach((file) => {
            const reader = new FileReader();
            reader.onload = () => {
                if (reader.readyState === 2) {
                    dispatch(uploadGlassInsideImage({ image: reader.result }));
                }
            };
            reader.readAsDataURL(file);
        });
    };
    const handleOdometerImage = async (e) => {
        const files = Array.from(e.target.files);
        files.forEach((file) => {
            const reader = new FileReader();
            reader.onload = () => {
                if (reader.readyState === 2) {
                    dispatch(uploadOdometerImage({ image: reader.result }));
                }
            };
            reader.readAsDataURL(file);
        });
    };
    const handleRpmImage = async (e) => {
        const files = Array.from(e.target.files);
        files.forEach((file) => {
            const reader = new FileReader();
            reader.onload = () => {
                if (reader.readyState === 2) {
                    dispatch(uploadRpmImage({ image: reader.result }));
                }
            };
            reader.readAsDataURL(file);
        });
    };
    const handleAnyDamage = async (e) => {
        const files = Array.from(e.target.files);
        files.forEach((file) => {
            const reader = new FileReader();
            reader.onload = () => {
                if (reader.readyState === 2) {
                    dispatch(uploadAnyDamage({ image: reader.result }));
                }
            };
            reader.readAsDataURL(file);
        });
    };
    const handleExtraImage = async (e) => {
        const files = Array.from(e.target.files);
        files.forEach((file) => {
            const reader = new FileReader();
            reader.onload = () => {
                if (reader.readyState === 2) {
                    dispatch(uploadExtraImage({ image: reader.result }));
                }
            };
            reader.readAsDataURL(file);
        });
    };
    const handleExtraImage1 = async (e) => {
        const files = Array.from(e.target.files);
        files.forEach((file) => {
            const reader = new FileReader();
            reader.onload = () => {
                if (reader.readyState === 2) {
                    dispatch(uploadExtraImage1({ image: reader.result }));
                }
            };
            reader.readAsDataURL(file);
        });
    };
    const handleExtraImage2 = async (e) => {
        const files = Array.from(e.target.files);
        files.forEach((file) => {
            const reader = new FileReader();
            reader.onload = () => {
                if (reader.readyState === 2) {
                    dispatch(uploadExtraImage2({ image: reader.result }));
                }
            };
            reader.readAsDataURL(file);
        });
    };
    const handleExtraImage3 = async (e) => {
        const files = Array.from(e.target.files);
        files.forEach((file) => {
            const reader = new FileReader();
            reader.onload = () => {
                if (reader.readyState === 2) {
                    dispatch(uploadExtraImage3({ image: reader.result }));
                }
            };
            reader.readAsDataURL(file);
        });
    };
    const handleSignature = async (e) => {
        const files = Array.from(e.target.files);
        files.forEach((file) => {
            const reader = new FileReader();
            reader.onload = () => {
                if (reader.readyState === 2) {
                    dispatch(uploadSignature({ image: reader.result }));
                }
            };
            reader.readAsDataURL(file);
        });
    };
    const handleFrontRc = async (e) => {
        const files = Array.from(e.target.files);
        files.forEach((file) => {
            const reader = new FileReader();
            reader.onload = () => {
                if (reader.readyState === 2) {
                    dispatch(uploadRcFront({ image: reader.result }));
                }
            };
            reader.readAsDataURL(file);
        });
    };
    const handleBackRc = async (e) => {
        const files = Array.from(e.target.files);
        files.forEach((file) => {
            const reader = new FileReader();
            reader.onload = () => {
                if (reader.readyState === 2) {
                    dispatch(uploadRcBackImage({ image: reader.result }));
                }
            };
            reader.readAsDataURL(file);
        });
    };

    const selectAirConditionerChange = (e) => {
        const { value } = e.target;
        const index = e.nativeEvent.target.selectedIndex;
        const text = e.nativeEvent.target[index].text;
        setAirConditioner(text);
    };
    const selectCdChargeChange = (e) => {
        const { value } = e.target;
        const index = e.nativeEvent.target.selectedIndex;
        const text = e.nativeEvent.target[index].text;
        setCdCharge(text);
    };
    const selectSeatCoverChange = (e) => {
        const { value } = e.target;
        const index = e.nativeEvent.target.selectedIndex;
        const text = e.nativeEvent.target[index].text;
        setSeatCover(text);
    };
    const selectFogLampsChange = (e) => {
        const { value } = e.target;
        const index = e.nativeEvent.target.selectedIndex;
        const text = e.nativeEvent.target[index].text;
        setFogLamps(text);
    };
    const selectTransmissionChange = (e) => {
        const { value } = e.target;
        const index = e.nativeEvent.target.selectedIndex;
        const text = e.nativeEvent.target[index].text;
        setTransmission(text);
    };
    const selectOdometerChange = (e) => {
        const { value } = e.target;
        const index = e.nativeEvent.target.selectedIndex;
        const text = e.nativeEvent.target[index].text;
        setOdometer(text);
    };
    const selectAccidentalChange = (e) => {
        const { value } = e.target;
        const index = e.nativeEvent.target.selectedIndex;
        const text = e.nativeEvent.target[index].text;
        setAccidental(text);
    };
    const selectotherRepairlChange = (e) => {
        const { value } = e.target;
        const index = e.nativeEvent.target.selectedIndex;
        const text = e.nativeEvent.target[index].text;
        setotherRepair(text);
    };
    const selectEngineConditionChange = (e) => {
        const { value } = e.target;
        const index = e.nativeEvent.target.selectedIndex;
        const text = e.nativeEvent.target[index].text;
        setEngineCondition(text);
    };
    const selectWheelTypeChange = (e) => {
        const { value } = e.target;
        const index = e.nativeEvent.target.selectedIndex;
        const text = e.nativeEvent.target[index].text;
        setWheelType(text);
    };
    const selectInteriorConditionChange = (e) => {
        const { value } = e.target;
        const index = e.nativeEvent.target.selectedIndex;
        const text = e.nativeEvent.target[index].text;
        setInteriorCondition(text);
    };
    const selectExteriorConditionChange = (e) => {
        const { value } = e.target;
        const index = e.nativeEvent.target.selectedIndex;
        const text = e.nativeEvent.target[index].text;
        setExteriorCondition(text);
    };
    const selectHeadLampChange = (e) => {
        const { value } = e.target;
        const index = e.nativeEvent.target.selectedIndex;
        const text = e.nativeEvent.target[index].text;
        setHeadLamp(text);
    };
    const selectTailLampChange = (e) => {
        const { value } = e.target;
        const index = e.nativeEvent.target.selectedIndex;
        const text = e.nativeEvent.target[index].text;
        setTailLamp(text);
    };
    const selectFrontIndicatorsChange = (e) => {
        const { value } = e.target;
        const index = e.nativeEvent.target.selectedIndex;
        const text = e.nativeEvent.target[index].text;
        setFrontIndicators(text);
    };
    const selectRearIndicatorsChange = (e) => {
        const { value } = e.target;
        const index = e.nativeEvent.target.selectedIndex;
        const text = e.nativeEvent.target[index].text;
        setRearIndicators(text);
    };
    const selectMaintenanceLevelChange = (e) => {
        const { value } = e.target;
        const index = e.nativeEvent.target.selectedIndex;
        const text = e.nativeEvent.target[index].text;
        setMaintenanceLevel(text);
    };
    const selectFrontBreakConditionChange = (e) => {
        const { value } = e.target;
        const index = e.nativeEvent.target.selectedIndex;
        const text = e.nativeEvent.target[index].text;
        setFrontBreakCondition(text);
    };
    const selectRearBreakConditionChange = (e) => {
        const { value } = e.target;
        const index = e.nativeEvent.target.selectedIndex;
        const text = e.nativeEvent.target[index].text;
        setRearBreakCondition(text);
    };
    const selectsetFrontCrashGuardChange = (e) => {
        const { value } = e.target;
        const index = e.nativeEvent.target.selectedIndex;
        const text = e.nativeEvent.target[index].text;
        setComFrontCrashGuard(text);
    };
    const selectComLoadCarrierChange = (e) => {
        const { value } = e.target;
        const index = e.nativeEvent.target.selectedIndex;
        const text = e.nativeEvent.target[index].text;
        setComLoadCarrier(text);
    };
    const selectComMusicSystemChange = (e) => {
        const { value } = e.target;
        const index = e.nativeEvent.target.selectedIndex;
        const text = e.nativeEvent.target[index].text;
        setComMusicSystem(text);
    };
    const selectComRearUnderRunChange = (e) => {
        const { value } = e.target;
        const index = e.nativeEvent.target.selectedIndex;
        const text = e.nativeEvent.target[index].text;
        setComRearUnderRun(text);
    };
    const selectComSideUnderRunChange = (e) => {
        const { value } = e.target;
        const index = e.nativeEvent.target.selectedIndex;
        const text = e.nativeEvent.target[index].text;
        setComSideUnderRun(text);
    };
    const selectComToolkitChange = (e) => {
        const { value } = e.target;
        const index = e.nativeEvent.target.selectedIndex;
        const text = e.nativeEvent.target[index].text;
        setComToolkit(text);
    };
    const selectComTvVideoChange = (e) => {
        const { value } = e.target;
        const index = e.nativeEvent.target.selectedIndex;
        const text = e.nativeEvent.target[index].text;
        setComTvVideo(text);
    };
    const selectComBodyConditionChange = (e) => {
        const { value } = e.target;
        const index = e.nativeEvent.target.selectedIndex;
        const text = e.nativeEvent.target[index].text;
        setComBodyCondition(text);
    };
    const selectComHandBrakeChange = (e) => {
        const { value } = e.target;
        const index = e.nativeEvent.target.selectedIndex;
        const text = e.nativeEvent.target[index].text;
        setComHandBrake(text);
    };
    const selectComDoorConditionChange = (e) => {
        const { value } = e.target;
        const index = e.nativeEvent.target.selectedIndex;
        const text = e.nativeEvent.target[index].text;
        setComDoorCondition(text);
    };
    const selectComSideGlassesConditionChange = (e) => {
        const { value } = e.target;
        const index = e.nativeEvent.target.selectedIndex;
        const text = e.nativeEvent.target[index].text;
        setComSideGlassesCondition(text);
    };
    const selectComWindscreenConditionChange = (e) => {
        const { value } = e.target;
        const index = e.nativeEvent.target.selectedIndex;
        const text = e.nativeEvent.target[index].text;
        setComWindscreenCondition(text);
    };
    const selectComBatteryConditionChange = (e) => {
        const { value } = e.target;
        const index = e.nativeEvent.target.selectedIndex;
        const text = e.nativeEvent.target[index].text;
        setComBatteryCondition(text);
    };
    const selectComClusterUnitConditionChange = (e) => {
        const { value } = e.target;
        const index = e.nativeEvent.target.selectedIndex;
        const text = e.nativeEvent.target[index].text;
        setComClusterUnitCondition(text);
    };
    const selectComFogLampStatusChange = (e) => {
        const { value } = e.target;
        const index = e.nativeEvent.target.selectedIndex;
        const text = e.nativeEvent.target[index].text;
        setComFogLampStatus(text);
    };
    const selectComWiperStatusChange = (e) => {
        const { value } = e.target;
        const index = e.nativeEvent.target.selectedIndex;
        const text = e.nativeEvent.target[index].text;
        setComWiperStatus(text);
    };
    const selectComEngineStatusChange = (e) => {
        const { value } = e.target;
        const index = e.nativeEvent.target.selectedIndex;
        const text = e.nativeEvent.target[index].text;
        setComEngineStatus(text);
    };
    const selectComEngineShieldConditionChange = (e) => {
        const { value } = e.target;
        const index = e.nativeEvent.target.selectedIndex;
        const text = e.nativeEvent.target[index].text;
        setComEngineShieldCondition(text);
    };
    const selectComFluidLeakStatusChange = (e) => {
        const { value } = e.target;
        const index = e.nativeEvent.target.selectedIndex;
        const text = e.nativeEvent.target[index].text;
        setComFluidLeakStatus(text);
    };
    const selectComSuspensionConditionChange = (e) => {
        const { value } = e.target;
        const index = e.nativeEvent.target.selectedIndex;
        const text = e.nativeEvent.target[index].text;
        setComSuspensionCondition(text);
    };
    const selectComTransmissionConditionChange = (e) => {
        const { value } = e.target;
        const index = e.nativeEvent.target.selectedIndex;
        const text = e.nativeEvent.target[index].text;
        setComTransmissionCondition(text);
    };
    const selectComAxleOneLeftInChange = (e) => {
        const { value } = e.target;
        const index = e.nativeEvent.target.selectedIndex;
        const text = e.nativeEvent.target[index].text;
        setComAxleOneLeftIn(text);
    };
    const selectComAxleOneLeftOutChange = (e) => {
        const { value } = e.target;
        const index = e.nativeEvent.target.selectedIndex;
        const text = e.nativeEvent.target[index].text;
        setComAxleOneLeftOut(text);
    };
    const selectComAxleOneRightInChange = (e) => {
        const { value } = e.target;
        const index = e.nativeEvent.target.selectedIndex;
        const text = e.nativeEvent.target[index].text;
        setComAxleOneRightIn(text);
    };
    const selectComAxleOneRightOutChange = (e) => {
        const { value } = e.target;
        const index = e.nativeEvent.target.selectedIndex;
        const text = e.nativeEvent.target[index].text;
        setComAxleOneRightOut(text);
    };
    const selectComAxleThreeLeftInChange = (e) => {
        const { value } = e.target;
        const index = e.nativeEvent.target.selectedIndex;
        const text = e.nativeEvent.target[index].text;
        setComAxleThreeLeftIn(text);
    };
    const selectComAxleThreeLeftOutChange = (e) => {
        const { value } = e.target;
        const index = e.nativeEvent.target.selectedIndex;
        const text = e.nativeEvent.target[index].text;
        setComAxleThreeLeftOut(text);
    };
    const selectComAxleThreeRightInChange = (e) => {
        const { value } = e.target;
        const index = e.nativeEvent.target.selectedIndex;
        const text = e.nativeEvent.target[index].text;
        setComAxleThreeRightIn(text);
    };
    const selectComAxleThreeRightOutChange = (e) => {
        const { value } = e.target;
        const index = e.nativeEvent.target.selectedIndex;
        const text = e.nativeEvent.target[index].text;
        setComAxleThreeRightOut(text);
    };
    const selectComAxleTwoLeftInChange = (e) => {
        const { value } = e.target;
        const index = e.nativeEvent.target.selectedIndex;
        const text = e.nativeEvent.target[index].text;
        setComAxleTwoLeftIn(text);
    };
    const selectComAxleTwoLeftOutChange = (e) => {
        const { value } = e.target;
        const index = e.nativeEvent.target.selectedIndex;
        const text = e.nativeEvent.target[index].text;
        setComAxleTwoLeftOut(text);
    };
    const selectComAxleTwoRightInChange = (e) => {
        const { value } = e.target;
        const index = e.nativeEvent.target.selectedIndex;
        const text = e.nativeEvent.target[index].text;
        setComAxleTwoRightIn(text);
    };
    const selectComAxleTwoRightOutChange = (e) => {
        const { value } = e.target;
        const index = e.nativeEvent.target.selectedIndex;
        const text = e.nativeEvent.target[index].text;
        setComAxleTwoRightOut(text);
    };
    const selectComFrontOneLeftChange = (e) => {
        const { value } = e.target;
        const index = e.nativeEvent.target.selectedIndex;
        const text = e.nativeEvent.target[index].text;
        setComFrontOneLeft(text);
    };
    const selectComFrontOneRightChange = (e) => {
        const { value } = e.target;
        const index = e.nativeEvent.target.selectedIndex;
        const text = e.nativeEvent.target[index].text;
        setComFrontOneRight(text);
    };
    const selectComFrontTwoLeftChange = (e) => {
        const { value } = e.target;
        const index = e.nativeEvent.target.selectedIndex;
        const text = e.nativeEvent.target[index].text;
        setComFrontTwoLeft(text);
    };
    const selectComFrontTwoRightChange = (e) => {
        const { value } = e.target;
        const index = e.nativeEvent.target.selectedIndex;
        const text = e.nativeEvent.target[index].text;
        setComFrontTwoRight(text);
    };
    const selectComFrontTruckTyreConditionChange = (e) => {
        const { value } = e.target;
        const index = e.nativeEvent.target.selectedIndex;
        const text = e.nativeEvent.target[index].text;
        setComFrontTruckTyreCondition(text);
    };
    const selectComFrontTruckTyreTypeChange = (e) => {
        const { value } = e.target;
        const index = e.nativeEvent.target.selectedIndex;
        const text = e.nativeEvent.target[index].text;
        setComFrontTruckTyreType(text);
    };
    const selectComAxleConditionChange = (e) => {
        const { value } = e.target;
        const index = e.nativeEvent.target.selectedIndex;
        const text = e.nativeEvent.target[index].text;
        setComAxleCondition(text);
    };
    const selectYourRemarkChange = (e) => {
        const { value } = e.target;
        const index = e.nativeEvent.target.selectedIndex;
        const text = e.nativeEvent.target[index].text;
        setYourRemark(text);
    };


    const [btnPress, setbtnPress] = useState(false);

    useEffect(() => {
        if (btnPress === true) {
            if (name === "") {
                setNameError("please enter title");
            } else {
                setNameError("");
            }
            if (Cnfemail === "") {
                setEmailError("please enter email");
            } else {
                setEmailError("");
            }
            if (mobileCnf.length !== 10) {
                setMobileError("please enter mobile");
            } else {
                setMobileError("");
            }
        }
    }, [btnPress, name, Cnfemail, mobileCnf]);

    const setNumberChange = async (e) => {
        const value = e.target.value.replace(/\D/g, "");
        setMobileError("");
        setMobile(value);
        if (value.length === 10) {
            // const verifyNumber = await dispatch(valiadteNumber(value));
            // if (verifyNumber.payload.success) {
            //     setMobileError("Number already exist");
            // } else {
            // }
            setMobileError("");
            setMobileCnf(value);
        } else {
            setMobileError("Please Enter Valid Number");
        }
    };

    const emailChange = async (e) => {
        const value = e;
        const mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
        setEmail(value);
        setEmailError("");
        if (value.length > 0) {
            if (value.match(mailformat)) {
                // const verifyEmail = await dispatch(valiadteEmail(value));
                // if (verifyEmail.payload.success) {
                //     setEmailError("Number already exist");
                // } else {
                // }
                setEmailError("");
                setCnfEmail(value);
            } else {
                setEmailError("please enter correct Email format");
            }
        } else {
            setEmailError("please enter correct Email format");
        }
    };

    const cancelClick = async (e) => {
        e.preventDefault();
        setEmail("");
        setCnfEmail("");
        setMobile("");
        setMobileCnf("");
        setName("");
    };

    const handlesubmit = async (e) => {
        e.preventDefault();
        if (name === "") {
            setNameError("please enter title");
        } else {
            setNameError("");
        }
        if (Cnfemail === "") {
            setEmailError("please enter email");
        } else {
            setEmailError("");
        }
        if (mobileCnf.length !== 10) {
            setMobileError("please enter mobile");
        } else {
            setMobileError("");
        }
        if (name !== "" && Cnfemail !== "" && mobileCnf !== "") {
            const formData = {
                assetType: assetType,
                caseType: caseType,
                valuationPurpose: valuationPurpose,
                vehicleLocation: vehicleLocation,
                requesterName: requesterName,
                requesterBranch: requesterBranch,
                requesterPhone: requesterPhone,
                name: name,
                mobile: mobileCnf,
                email: Cnfemail,
                address: address,
                state: state,
                city: city,
                regdNo: regdNo,
                productType: productType,
                brand: productBrand,
                model: model,
                variant: variant,
                loanAgreementNo: loanNo,
                documentVerification: docVerified,
                regdOwner: regdOwner,
                regdDate: regdDate,
                numberPlate: numberPlateType,
                engNo: engNo,
                chasisNo: chasisNo,
                bodyType: bodyType,
                manufacturingDate: mfgDate,
                fueltype: fueltype,
                vehicleColor: vehicleColor,
                ownerSerialNo: ownerSerialNo,
                hypothecationBank: hypothecationBank,
                cubicCapacity: cubicCapacity,
                seatingCapacity: seatingCapacity,
                vehicleWeight: vehicleWeight,
                videos:videoRecord,
                images: {
                    selfieWithVehicle: selfieWithVehicleImage,
                    chasisImage: chasisImage,
                    format: formatImage,
                    openBonnet: openBonnet,
                    right45: right45image,
                    frontImage: frontimage,
                    frontUnderCar: frontUnderCarImage,
                    left45: left45image,
                    leftImage: leftImage,
                    rearImage: rearImage,
                    rearUnderPart: rearUnderPartImage,
                    openDickey: openDickeyImage,
                    rightImage: rightImage,
                    tyreImage: tyreImage,
                    glassOutside: glassOutsideImage,
                    glassInside: glassInsideImage,
                    odometerImage: odometerImage,
                    rpmImage: rpmImage,
                    anyDamage: anyDamage,
                    extraImage: extraImage,
                    extraImage1: extraImage1,
                    extraImage2: extraImage2,
                    extraImage3: extraImage3,
                },
                signNdoc: {
                    sign: signatureImage,
                    rcFront: rcFrontImage,
                    rcBack: rcBackImage,
                },
                accessories: {
                    ac: airConditioner,
                    cdCharger: cdCharge,
                    seatCover: seatCover,
                    fogLamps: fogLamps,
                },
                additionalFeatures: {
                    transmission: transmission,
                    odometer: odometer,
                },
                otherDetails: {
                    accidental: accidental,
                    otherRepair: otherRepair,
                    fitnessExpiry: fitnessExpiry,
                    roadTaxValidity: roadtaxValidity,
                    IDVValue: idvValue,
                    insuranceExpiry: insuranceExpiry,
                    engineCondition: engineCondition,
                    frontBrakeCondition: frontBrakeCondition,
                    rearBrakeCondition: rearBrakeCondition,
                    wheelsType: wheelType,
                    totalTyre: totalTyre,
                    availableTyre: availableTyre,
                    missingTyre: missingTyre,
                    spareTyre: spareTyre,
                    interiorCondition: interiorCondition,
                    exteriorCondition: exteriorCondition,
                    headLamp: headLamp,
                    tailLamp: tailLamp,
                    frontIndicators: frontIndicators,
                    rearIndicators: rearIndicators,
                    levelOfMaintenance: maintenanceLevel,
                },
                commercial: {
                    engine: {
                        engine: comEngineStatus,
                        fluidLeak: comFluidLeakStatus,
                        engineShield: comEngineShieldCondition,
                    },
                    transmission: {
                        transmissionCondition: comTransmissionCondition,
                    },
                    suspension: {
                        suspensionCondition: comSuspensionCondition,
                    },
                    brakes: {
                        handBrake: comHandBrake,
                    },
                    tyresNConditions: {
                        tyreType: comFrontTruckTyreType,
                        truckTyreCondition: comFrontTruckTyreCondition,
                        axlesCondition: comAxleCondition,
                        frontOneLeft: comFrontOneLeft,
                        frontTwoLeft: comFrontTwoLeft,
                        axleOneLeftIn: comAxleOneLeftIn,
                        axleOneRightIn: comAxleOneRightIn,
                        axleTwoLeftIn: comAxleTwoLeftIn,
                        axleTwoRightIn: comAxleTwoRightIn,
                        axleThreeLeftIn: comAxleThreeLeftIn,
                        axleThreeRightIn: comAxleThreeRightIn,
                        frontOneRight: comFrontOneRight,
                        frontTwoRight: comFrontTwoRight,
                        axleOneLeftOut: comAxleOneRightIn,
                        axleOneRightOut: comAxleOneRightOut,
                        axleTwoLeftOut: comAxleTwoRightIn,
                        axleTwoRightOut: comAxleTwoRightOut,
                        axleThreeLeftOut: comAxleThreeLeftOut,
                        axleThreeRightOut: comAxleThreeRightOut,
                    },
                    cabinNinterior: {
                        windScreen: comWindscreenCondition,
                        sideGlasses: comSideGlassesCondition,
                        doors: comDoorCondition,
                    },
                    electricals: {
                        noOfBatteries: comBatteryNo,
                        batteryCondition: comBatteryCondition,
                        clusterUnit: comClusterUnitCondition,
                        fogLamps: comFogLampStatus,
                        wiper: comWiperStatus,
                    },
                    accessories: {
                        frontCrashGuard: comFrontCrashGuard,
                        loadCarrier: comLoadCarrier,
                        musicSystem: comMusicSystem,
                        tvNvideoPlayer: comTvVideo,
                        rearUnderRunProtection: comRearUnderRun,
                        sideUnderRunProtection: comSideUnderRun,
                        toolKit: comToolkit,
                    },
                    body: {
                        bodyCondition: comBodyCondition,
                    },
                },
                yourRemark: yourRemark,
                valuation: estimatedPrice,
                marketPrice: exShowRoomPrice,
                status: 4,
                statusText: 'Case Submitted',
            };
            console.log(formData, "formData")
            const newcase = await dispatch(createCase(formData))
            if (newcase.payload.success) {
                alert("Case created successfully");
                dispatch(CaseActions.afterPost())
                navigate('/admin/submittedcases')
                setEmail("");
                setCnfEmail("");
                setMobile("");
                setMobileCnf("");
                setName("");
                setRole("")
                setAddress("")
                setState("")
                setCity("")
                setProductType("")
                setProductBrand("")
                setModel("")
                setVariant("")
                setLoanNo("")
                setDocVerified("")
                setRegdOwner("")
                setRegdDate("")
                setMfgdate("")
                setNumberPlateType("")
                setRegdNo("")
                setEngNo("")
                setChasisNo("")
                setBodyType("")
                setFueltype("")
                setVehicleColor("")
                setOwnerSerialNo("")
                setHypothecationBank("")
                setCubicCapacity("")
                setSeatingCapacity("")
                setVehicleWeight("")
                setSeatCover("")
                setFogLamps("")
                setTransmission("")
                setAccidental("")
                setFitnessExpiry("")
                setInsuranceExpiry("")
            }
        } else {
            setbtnPress(true);
        }
    };

    return (
        <>
            <div className="min-h-screen flex flex-col lg:ps-64 w-full">
                <div className="p-6 space-y-6">
                    <div className="flex items-center justify-between w-full print:hidden">
                        <h4 className="text-lg font-semibold text-default-900">
                            Add Commercial Case Details
                        </h4>
                    </div>
                    <div className="shadow rounded-lg bg-white dark:bg-default-50 h-fit">
                        <div className="flex items-center justify-between py-4 px-5">
                            <h4 className="text-lg font-medium text-default-950 capitalize">
                                Add Commercial Case Details
                            </h4>
                        </div>
                        <div className="p-5 border-t border-dashed border-default-200">
                            <div className="grid md:grid-cols-2 gap-4">
                                <div className="space-y-1">
                                    <label
                                        htmlFor="fName"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Case Type *
                                    </label>
                                    <select
                                        className={
                                            caseTypeError === ""
                                                ? `border-default-200 w-full`
                                                : `border-default-200 w-full error_class`
                                        }
                                        data-trigger
                                        id="choices-single-default"
                                        placeholder="This is a search placeholder"
                                        value={selectCaseType.id}
                                        name={selectCaseType.name}
                                        onChange={(e) => selectCaseChange(e)}
                                    >
                                        <option value="0" hidden selected>
                                            Choose Case Type
                                        </option>
                                        {selectCaseType.map((test, index) => (
                                            <option
                                                key={index}
                                                value={test.id}
                                                name={test.name}
                                                required
                                            >
                                                {test.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="fAssetType"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Asset Type *
                                    </label>
                                    <select
                                        className={
                                            assetTypeError === ""
                                                ? `border-default-200 w-full`
                                                : `border-default-200 w-full error_class`
                                        }
                                        data-trigger
                                        id="fAssetType"
                                        placeholder="This is a search placeholder"
                                        value={selectAssetType.id}
                                        name={selectAssetType.name}
                                        onChange={(e) => selectAssetChange(e)}
                                    >
                                        <option value="0" hidden selected>
                                            Choose Asset Type
                                        </option>
                                        {selectAssetType.map((test, index) => (
                                            <option
                                                key={index}
                                                value={test.id}
                                                name={test.name}
                                                required
                                            >
                                                {test.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="fValuationPurpose"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Purpose Of Valuation *
                                    </label>
                                    <input
                                        type="text"
                                        className={
                                            valuationPurposeError !== ""
                                                ? "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50 error_class"
                                                : "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                        id="fValuationPurpose"
                                        placeholder="Enter Valuation Purpose"
                                        value={valuationPurpose}
                                        onChange={(e) => setValuationPurpose(e.target.value)}
                                    />
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="fName"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Valuation Requested By *
                                    </label>
                                    <input
                                        type="text"
                                        className={
                                            requesterNameError !== ""
                                                ? "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50 error_class"
                                                : "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                        id="fName"
                                        placeholder="Enter Requester Name"
                                        value={requesterName}
                                        onChange={(e) => setRequesterName(e.target.value)}
                                    />
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="fName"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Requester Branch Name *
                                    </label>
                                    <input
                                        type="text"
                                        className={
                                            requesterBranchError !== ""
                                                ? "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50 error_class"
                                                : "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                        id="fName"
                                        placeholder="Enter Requester Branch"
                                        value={requesterBranch}
                                        onChange={(e) => setRequesterBranch(e.target.value)}
                                    />
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="lName"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Requester Phone *
                                    </label>
                                    <input
                                        type="text"
                                        className={
                                            requesterPhoneError !== ""
                                                ? "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50 error_class"
                                                : "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                        id="lName"
                                        placeholder="Enter Requester Phone"
                                        minLength={10}
                                        maxLength={10}
                                        value={requesterPhone}
                                        onChange={(e) => handleRequesterPhn(e)}
                                    />
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="fName"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Customer Name *
                                    </label>
                                    <input
                                        type="text"
                                        className={
                                            nameError !== ""
                                                ? "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50 error_class"
                                                : "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                        id="fName"
                                        placeholder="Enter Customer Name"
                                        value={name}
                                        onChange={(e) => setName(e.target.value.trim())}
                                    />
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="lName"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Customer  Phone *
                                    </label>
                                    <input
                                        type="text"
                                        className={
                                            mobileError !== ""
                                                ? "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50 error_class"
                                                : "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                        id="lName"
                                        placeholder="Enter Customer Phone"
                                        minLength={10}
                                        maxLength={10}
                                        value={mobile}
                                        onChange={(e) => setNumberChange(e)}
                                    />
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="lName"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Customer Email *
                                    </label>
                                    <input
                                        type="text"
                                        className={
                                            emailError !== ""
                                                ? "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50 error_class"
                                                : "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                        id="rollNo"
                                        placeholder="Enter Customer Email"
                                        value={email}
                                        onChange={(e) => emailChange(e.target.value)}
                                    />
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="Address"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Customer Address *
                                    </label>
                                    <input
                                        type="text"
                                        className={
                                            addressError !== ""
                                                ? "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50 error_class"
                                                : "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                        id="Address"
                                        placeholder="Enter Customer Address"
                                        value={address}
                                        onChange={(e) => setAddress(e.target.value)}
                                    />
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="fState"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Select State *
                                    </label>
                                    <select
                                        className={
                                            stateError === ""
                                                ? `border-default-200 w-full`
                                                : `border-default-200 w-full error_class`
                                        }
                                        data-trigger
                                        id="fState"
                                        placeholder="This is a search placeholder"
                                        value={stateList.id}
                                        name={stateList.name}
                                        onChange={(e) => selectStateChange(e)}
                                    >
                                        <option value="0" hidden selected>
                                            Choose State Type
                                        </option>
                                        {stateList.map((test, index) => (
                                            <option
                                                key={index}
                                                value={test.id}
                                                name={test.name}
                                                required
                                            >
                                                {test.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="fCity"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Select City *
                                    </label>
                                    <select
                                        className={
                                            cityError === ""
                                                ? `border-default-200 w-full`
                                                : `border-default-200 w-full error_class`
                                        }
                                        data-trigger
                                        id="fCity"
                                        placeholder="This is a search placeholder"
                                        value={cityList.id}
                                        name={cityList.name}
                                        onChange={(e) => selectCityChange(e)}
                                    >
                                        <option value="0" hidden selected>
                                            Choose City Type
                                        </option>
                                        {cityList.map((test, index) => (
                                            <option
                                                key={index}
                                                value={test.id}
                                                name={test.name}
                                                required
                                            >
                                                {test.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="regdNo"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        RegdNo *
                                    </label>
                                    <input
                                        type="text"
                                        className={
                                            regdNoError !== ""
                                                ? "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50 error_class"
                                                : "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                        id="regdNo"
                                        placeholder="Enter Regd No"
                                        value={regdNo}
                                        onChange={(e) => setRegdNo(e.target.value)}
                                    />
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="vehcileLocation"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Vehicle Location *
                                    </label>
                                    <input
                                        type="text"
                                        className={
                                            vehicleLocationError !== ""
                                                ? "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50 error_class"
                                                : "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                        id="vehcileLocation"
                                        placeholder="Enter Vehcile Location"
                                        value={vehicleLocation}
                                        onChange={(e) => setVehicleLocation(e.target.value)}
                                    />
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="productType"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Vehicle brand *
                                    </label>
                                    <input
                                        type="text"
                                        className={
                                            productBrandError !== ""
                                                ? "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50 error_class"
                                                : "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                        id="productType"
                                        placeholder="Enter Vehicle Brand"
                                        value={productBrand}
                                        onChange={(e) => setProductBrand(e.target.value)}
                                    />
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="model"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Vehicle model *
                                    </label>
                                    <input
                                        type="text"
                                        className={
                                            ModelError !== ""
                                                ? "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50 error_class"
                                                : "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                        id="model"
                                        placeholder="Enter Vehicle Model"
                                        value={model}
                                        onChange={(e) => setModel(e.target.value)}
                                    />
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="variant"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Vehicle variant *
                                    </label>
                                    <input
                                        type="text"
                                        className={
                                            variantError !== ""
                                                ? "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50 error_class"
                                                : "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                        id="variant"
                                        placeholder="Enter Vehicle Variant"
                                        value={variant}
                                        onChange={(e) => setVariant(e.target.value)}
                                    />
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="loanNo"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Loan Agreement No *
                                    </label>
                                    <input
                                        type="text"
                                        className={
                                            loanNoError !== ""
                                                ? "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50 error_class"
                                                : "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                        id="loanNo"
                                        placeholder="Enter Loan Agreement No"
                                        value={loanNo}
                                        onChange={(e) => setLoanNo(e.target.value)}
                                    />
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="fDocVerified"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Document Verified *
                                    </label>
                                    <select
                                        className={`border-default-200 w-full`}
                                        data-trigger
                                        id="fDocVerified"
                                        placeholder="This is a search placeholder"
                                        value={documents.id}
                                        name={documents.name}
                                        onChange={(e) =>
                                            selectDocuementVerifiedTypeChange(e)
                                        }
                                    >
                                        <option value="0" hidden selected>
                                            Choose Status
                                        </option>
                                        {documents.map((test, index) => (
                                            <option
                                                key={index}
                                                value={test.id}
                                                name={test.name}
                                                required
                                                selected={test.name === docVerified}
                                            >
                                                {test.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="regdOwner"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Regd Owner *
                                    </label>
                                    <input
                                        type="text"
                                        className={
                                            regdOwnerError !== ""
                                                ? "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50 error_class"
                                                : "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                        id="regdOwner"
                                        placeholder="Enter regd owner"
                                        value={regdOwner}
                                        onChange={(e) => setRegdOwner(e.target.value)}
                                    />
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="regdOwner"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Regd Date *
                                    </label>
                                    <input
                                        type="date"
                                        className={
                                            regdDateError !== ""
                                                ? "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50 error_class"
                                                : "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                        id="regdDate"
                                        placeholder="Enter product regd date"
                                        value={regdDate}
                                        onChange={(e) => setRegdDate(e.target.value)}
                                    />
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="fManufacturingDate"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Manufacturing Date <span style={{ color: 'red' }}>**</span>
                                    </label>
                                    <input
                                        type="date"
                                        className={
                                            "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                        id="fManufacturingDate"
                                        placeholder="Enter Manufacturing Date"
                                        value={mfgDate}
                                        onChange={(e) => setMfgdate(e.target.value)}
                                    />
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="fNumberPlate"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Number Plate Type *
                                    </label>
                                    <select
                                        className={`border-default-200 w-full`}
                                        data-trigger
                                        id="fNumberPlate"
                                        placeholder="This is a search placeholder"
                                        value={number.id}
                                        name={number.name}
                                        onChange={(e) =>
                                            selectNumberPlateTypeChange(e)
                                        }
                                    >
                                        <option value="0" hidden selected>
                                            Choose Number Plate Type
                                        </option>
                                        {number.map((test, index) => (
                                            <option
                                                key={index}
                                                value={test.id}
                                                name={test.name}
                                                required
                                                selected={test.name === numberPlateType}
                                            >
                                                {test.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="engNo"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Engine No *
                                    </label>
                                    <input
                                        type="text"
                                        className={
                                            engNoError !== ""
                                                ? "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50 error_class"
                                                : "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                        id="engNo"
                                        placeholder="Enter vehicle engine no"
                                        value={engNo}
                                        onChange={(e) => setEngNo(e.target.value)}
                                    />
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="chasisNo"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Chasis No *
                                    </label>
                                    <input
                                        type="text"
                                        className={
                                            chasisNoError !== ""
                                                ? "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50 error_class"
                                                : "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                        id="chasisNo"
                                        placeholder="Enter chasis no"
                                        value={chasisNo}
                                        onChange={(e) => setChasisNo(e.target.value)}
                                    />
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="bodyType"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Body Type *
                                    </label>
                                    <input
                                        type="text"
                                        className={
                                            bodyTypeError !== ""
                                                ? "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50 error_class"
                                                : "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                        id="bodyType"
                                        placeholder="Enter body type"
                                        value={bodyType}
                                        onChange={(e) => setBodyType(e.target.value)}
                                    />
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="fMeterReading"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Meter Reading *
                                    </label>
                                    <input
                                        type="text"
                                        className={
                                            "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                        id="fMeterReading"
                                        placeholder="Enter Meter Reading"
                                        value={meterReading}
                                        onChange={(e) => setMeterReading(e.target.value)}
                                    />
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="fueltype"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Fuel Type*
                                    </label>
                                    <input
                                        type="text"
                                        className={
                                            fueltypeError !== ""
                                                ? "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50 error_class"
                                                : "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                        id="fueltype"
                                        placeholder="Enter vehicle fuel type"
                                        value={fueltype}
                                        onChange={(e) => setFueltype(e.target.value)}
                                    />
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="fueltype"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Vehicle Color *
                                    </label>
                                    <input
                                        type="text"
                                        className={
                                            vehicleColorError !== ""
                                                ? "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50 error_class"
                                                : "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                        id="fueltype"
                                        placeholder="Enter vehicle color "
                                        value={vehicleColor}
                                        onChange={(e) => setVehicleColor(e.target.value)}
                                    />
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="vehicleWeight"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Gross Weight Of Vehicle *
                                    </label>
                                    <input
                                        type="text"
                                        className={
                                            vehicleWeightError !== ""
                                                ? "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50 error_class"
                                                : "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                        id="vehicleWeight"
                                        placeholder="Enter vehicle weight"
                                        value={vehicleWeight}
                                        onChange={(e) => setVehicleWeight(e.target.value)}
                                    />
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="ownerSerialNo"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Vehicle Owner Serial No *
                                    </label>
                                    <input
                                        type="text"
                                        className={
                                            ownerSerialNoError !== ""
                                                ? "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50 error_class"
                                                : "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                        id="ownerSerialNo"
                                        placeholder="Enter vehicle owner serial no "
                                        value={ownerSerialNo}
                                        onChange={(e) => setOwnerSerialNo(e.target.value)}
                                    />
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="ownerSerialNo"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Hypothecation Bank Name *
                                    </label>
                                    <input
                                        type="text"
                                        className={
                                            hypothecationBankError !== ""
                                                ? "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50 error_class"
                                                : "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                        id="ownerSerialNo"
                                        placeholder="Enter vehicle hypothecation bank name "
                                        value={hypothecationBank}
                                        onChange={(e) => setHypothecationBank(e.target.value)}
                                    />
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="fInsuranceCompany"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Insurance Company Name *
                                    </label>
                                    <input
                                        type="text"
                                        className={
                                            "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                        id="fInsuranceCompany"
                                        placeholder="Enter Insurance Company Name"
                                        value={insuranceCompany}
                                        onChange={(e) => setInsuranceCompany(e.target.value)}
                                    />
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="fInsuranceStatus"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Insurance Expired *
                                    </label>
                                    <select
                                        className={`border-default-200 w-full`}
                                        data-trigger
                                        id="fInsuranceStatus"
                                        placeholder="This is a search placeholder"
                                        value={options.id}
                                        name={options.name}
                                        onChange={(e) =>
                                            selectInsuranceStatusChange(e)
                                        }
                                    >
                                        <option value="0" hidden selected>
                                            Choose Insurance Status
                                        </option>
                                        {options.map((test, index) => (
                                            <option
                                                key={index}
                                                value={test.id}
                                                name={test.name}
                                                required
                                                selected={test.name === insuranceStatus}
                                            >
                                                {test.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="cubicCapacity"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Cubic  Capacity *
                                    </label>
                                    <input
                                        type="text"
                                        className={
                                            cubicCapacityError !== ""
                                                ? "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50 error_class"
                                                : "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                        id="cubicCapacity"
                                        placeholder="Enter product Cubic Capacity"
                                        value={cubicCapacity}
                                        onChange={(e) => setCubicCapacity(e.target.value)}
                                    />
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="seatingCapacity"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Seating Capacity *
                                    </label>
                                    <input
                                        type="text"
                                        className={
                                            eatingCapacityError !== ""
                                                ? "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50 error_class"
                                                : "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                        id="seatingCapacity"
                                        placeholder="Enter product seating capacity"
                                        value={seatingCapacity}
                                        onChange={(e) => setSeatingCapacity(e.target.value)}
                                    />
                                </div>
                                <div className="col-span-2 space-y-1">
                                    <label
                                        htmlFor="fLoanAgreement"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Vehicle Video *
                                    </label>
                                    {
                                        showLoader === true ? (<>
                                            <div style={{ height: '250px', width: '50%', backgroundColor: '#000', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                <Spinner animation="border" role="status">
                                                    <span className="visually-hidden">Loading...</span>
                                                </Spinner>
                                            </div>
                                        </>) : (<>
                                            <iframe
                                                title="Video Player"
                                                width="50%" // Set width to 100% to fill the container
                                                height="250px" // Set height to auto to maintain aspect ratio
                                                src={videoRecord}
                                                frameBorder="0"
                                                allowFullScreen
                                            ></iframe>
                                        </>)
                                    }
                                    <input type="file" id='videouploading' onChange={handleFileChange} accept="video/*" />
                                    {
                                        selectedVideo ? (
                                            <div>
                                                <button onClick={handleUpload} style={{ backgroundColor: '#ff6600', color: '#fff', padding: '5px 8px', borderRadius: '4px' }}>Upload Video</button>
                                            </div>) : (
                                            <div>
                                                <button style={{ backgroundColor: '#ff6600', opacity: '.5', color: '#fff', padding: '5px 8px', borderRadius: '4px' }}>Upload Video</button>
                                            </div>)
                                    }


                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="vehicleWeight"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Selfie With Vehicle *
                                    </label>
                                    <input type="file" onChange={handleSelfieWithVehicleChange}
                                        className={
                                            vehicleWeightError !== ""
                                                ? "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50 error_class"
                                                : "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                    />
                                    <div>
                                        {isSelfieWithAgentLoading ? (
                                            <div></div>
                                        ) : (
                                            <img src={selfieWithVehicleImage} style={{ height: '100px', width: '100px' }} alt="img" />
                                        )}
                                    </div>
                                </div>

                                <div className="space-y-1">
                                    <label
                                        htmlFor="Chasis Image"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Chasis Image *
                                    </label>
                                    <input type="file" onChange={handleChasisChange}
                                        className={
                                            vehicleWeightError !== ""
                                                ? "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50 error_class"
                                                : "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                    />
                                    <div>
                                        {isChasisImageLoading ? (
                                            <div></div>
                                        ) : (
                                            <img src={chasisImage} style={{ height: '100px', width: '100px' }} alt="img" />
                                        )}
                                    </div>
                                </div>

                                <div className="space-y-1">
                                    <label
                                        htmlFor="formatfile"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Product Format Image *
                                    </label>
                                    <input type="file" onChange={handleFormatChange}
                                        className={
                                            vehicleWeightError !== ""
                                                ? "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50 error_class"
                                                : "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                    />
                                    <div>
                                        {IsformatImageLoading ? (
                                            <div></div>
                                        ) : (
                                            <img src={formatImage} style={{ height: '100px', width: '100px' }} alt="img" />
                                        )}
                                    </div>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="openBonnetfile"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Open Bonnet Image *
                                    </label>
                                    <input type="file" onChange={handleOpenBonnetChange}
                                        className={
                                            vehicleWeightError !== ""
                                                ? "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50 error_class"
                                                : "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                    />
                                    <div>
                                        {isOpenBonnetLoading ? (
                                            <div></div>
                                        ) : (
                                            <img src={openBonnet} style={{ height: '100px', width: '100px' }} alt="img" />
                                        )}
                                    </div>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="openBonnetfile"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Right 45* Image *
                                    </label>
                                    <input type="file" onChange={handleright45Change}
                                        className={
                                            vehicleWeightError !== ""
                                                ? "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50 error_class"
                                                : "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                    />
                                    <div>
                                        {isRight45ImageLoading ? (
                                            <div></div>
                                        ) : (
                                            <img src={right45image} style={{ height: '100px', width: '100px' }} alt="img" />
                                        )}
                                    </div>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="frontImage"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Front Image *
                                    </label>
                                    <input type="file" onChange={frontImage}
                                        className={
                                            vehicleWeightError !== ""
                                                ? "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50 error_class"
                                                : "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                    />
                                    <div>
                                        {isFrontImageLoading ? (
                                            <div></div>
                                        ) : (
                                            <img src={frontimage} style={{ height: '100px', width: '100px' }} alt="img" />
                                        )}
                                    </div>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="frontUnderCar"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Front Under Car Image *
                                    </label>
                                    <input type="file" onChange={frontUnderCarImg}
                                        className={
                                            vehicleWeightError !== ""
                                                ? "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50 error_class"
                                                : "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                    />
                                    <div>
                                        {isFrontUnderCarImageLoading ? (
                                            <div></div>
                                        ) : (
                                            <img src={frontUnderCarImage} style={{ height: '100px', width: '100px' }} alt="img" />
                                        )}
                                    </div>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="left45file"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Left 45* Image *
                                    </label>
                                    <input type="file" onChange={handlesetLeft45Image}
                                        className={
                                            vehicleWeightError !== ""
                                                ? "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50 error_class"
                                                : "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                    />
                                    <div>
                                        {isLeft45Loading ? (
                                            <div></div>
                                        ) : (
                                            <img src={left45image} style={{ height: '100px', width: '100px' }} alt="img" />
                                        )}
                                    </div>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="leftfile"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Car Left Image *
                                    </label>
                                    <input type="file" onChange={handlesetLeftImage}
                                        className={
                                            vehicleWeightError !== ""
                                                ? "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50 error_class"
                                                : "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                    />
                                    <div>
                                        {isLeftImageLoading ? (
                                            <div></div>
                                        ) : (
                                            <img src={leftImage} style={{ height: '100px', width: '100px' }} alt="img" />
                                        )}
                                    </div>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="rearfile"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Car Rear Image *
                                    </label>
                                    <input type="file" onChange={handlesetRearImage}
                                        className={
                                            vehicleWeightError !== ""
                                                ? "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50 error_class"
                                                : "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                    />
                                    <div>
                                        {isRearImageLoading ? (
                                            <div></div>
                                        ) : (
                                            <img src={rearImage} style={{ height: '100px', width: '100px' }} alt="img" />
                                        )}
                                    </div>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="rearunderpartfile"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Car Rear Under Part Image *
                                    </label>
                                    <input type="file" onChange={handlerearUnderPartImage}
                                        className={
                                            vehicleWeightError !== ""
                                                ? "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50 error_class"
                                                : "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                    />
                                    <div>
                                        {isRearUnderPartLoading ? (
                                            <div></div>
                                        ) : (
                                            <img src={rearUnderPartImage} style={{ height: '100px', width: '100px' }} alt="img" />
                                        )}
                                    </div>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="rearunderpartfile"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Open Dickey Image *
                                    </label>
                                    <input type="file" onChange={handlerearOpenDickeyImage}
                                        className={
                                            vehicleWeightError !== ""
                                                ? "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50 error_class"
                                                : "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                    />
                                    <div>
                                        {isOpenDickeyImageLoading ? (
                                            <div></div>
                                        ) : (
                                            <img src={openDickeyImage} style={{ height: '100px', width: '100px' }} alt="img" />
                                        )}
                                    </div>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="handlerightImage"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Open Handle Right Image *
                                    </label>
                                    <input type="file" onChange={HandlerightImage}
                                        className={
                                            vehicleWeightError !== ""
                                                ? "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50 error_class"
                                                : "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                    />
                                    <div>
                                        {isRightImageLoading ? (
                                            <div></div>
                                        ) : (
                                            <img src={rightImage} style={{ height: '100px', width: '100px' }} alt="img" />
                                        )}
                                    </div>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="tyreImage"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Tyre Image *
                                    </label>
                                    <input type="file" onChange={handlesetTyreImage}
                                        className={
                                            vehicleWeightError !== ""
                                                ? "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50 error_class"
                                                : "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                    />
                                    <div>
                                        {isTyreImageLoading ? (
                                            <div></div>
                                        ) : (
                                            <img src={tyreImage} style={{ height: '100px', width: '100px' }} alt="img" />
                                        )}
                                    </div>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="glassOutside"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Glass Outside Image*
                                    </label>
                                    <input type="file" onChange={handleGlassOutsideImage}
                                        className={
                                            vehicleWeightError !== ""
                                                ? "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50 error_class"
                                                : "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                    />
                                    <div>
                                        {isGlassOutsideImageLoading ? (
                                            <div></div>
                                        ) : (
                                            <img src={glassOutsideImage} style={{ height: '100px', width: '100px' }} alt="img" />
                                        )}
                                    </div>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="glassOutside"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Glass Inside Image*
                                    </label>
                                    <input type="file" onChange={handleGlassInsideImage}
                                        className={
                                            vehicleWeightError !== ""
                                                ? "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50 error_class"
                                                : "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                    />
                                    <div>
                                        {isGlassInsideImageLoading ? (
                                            <div></div>
                                        ) : (
                                            <img src={glassInsideImage} style={{ height: '100px', width: '100px' }} alt="img" />
                                        )}
                                    </div>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="odometer"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Odometer Image*
                                    </label>
                                    <input type="file" onChange={handleOdometerImage}
                                        className={
                                            vehicleWeightError !== ""
                                                ? "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50 error_class"
                                                : "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                    />
                                    <div>
                                        {isOdometerImageLoading ? (
                                            <div></div>
                                        ) : (
                                            <img src={odometerImage} style={{ height: '100px', width: '100px' }} alt="img" />
                                        )}
                                    </div>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="rpmFile"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        RPM Image*
                                    </label>
                                    <input type="file" onChange={handleRpmImage}
                                        className={
                                            vehicleWeightError !== ""
                                                ? "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50 error_class"
                                                : "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                    />
                                    <div>
                                        {isRpmImageLoading ? (
                                            <div></div>
                                        ) : (
                                            <img src={rpmImage} style={{ height: '100px', width: '100px' }} alt="img" />
                                        )}
                                    </div>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="anyDamage"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Any Damage *
                                    </label>
                                    <input type="file" onChange={handleAnyDamage}
                                        className={
                                            vehicleWeightError !== ""
                                                ? "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50 error_class"
                                                : "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                    />
                                    <div>
                                        {isAnyDamageLoading ? (
                                            <div></div>
                                        ) : (
                                            <img src={anyDamage} style={{ height: '100px', width: '100px' }} alt="img" />
                                        )}
                                    </div>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="anyDamage"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Extra Damage *
                                    </label>
                                    <input type="file" onChange={handleExtraImage}
                                        className={
                                            "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                    />
                                    <div>
                                        {isExtraImageLoading ? (
                                            <div></div>
                                        ) : (
                                            <img src={extraImage} style={{ height: '100px', width: '100px' }} alt="img" />
                                        )}
                                    </div>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="anyDamage"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Extra Image 1 *
                                    </label>
                                    <input type="file" onChange={handleExtraImage1}
                                        className={
                                            "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                    />
                                    <div>
                                        {isExtraImage1Loading ? (
                                            <div></div>
                                        ) : (
                                            <img src={extraImage1} style={{ height: '100px', width: '100px' }} alt="img" />
                                        )}
                                    </div>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="anyDamage"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Extra Image 2 *
                                    </label>
                                    <input type="file" onChange={handleExtraImage2}
                                        className={
                                            "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                    />
                                    <div>
                                        {isExtraImage2Loading ? (
                                            <div></div>
                                        ) : (
                                            <img src={extraImage2} style={{ height: '100px', width: '100px' }} alt="img" />
                                        )}
                                    </div>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="anyDamage"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Extra Image 3 *
                                    </label>
                                    <input type="file" onChange={handleExtraImage3}
                                        className={
                                            "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                    />
                                    <div>
                                        {isExtraImage3Loading ? (
                                            <div></div>
                                        ) : (
                                            <img src={extraImage3} style={{ height: '100px', width: '100px' }} alt="img" />
                                        )}
                                    </div>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="signature"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Upload Your Signature*
                                    </label>

                                    <input type="file" onChange={handleSignature}
                                        className={
                                            vehicleWeightError !== ""
                                                ? "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50 error_class"
                                                : "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                    />
                                    <div>
                                        {isSignatureImageLoading ? (
                                            <div></div>
                                        ) : (
                                            <img src={signatureImage} style={{ height: '100px', width: '100px' }} alt="img" />
                                        )}
                                    </div>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="frontRc"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Upload Frontside of your RC*
                                    </label>
                                    <input type="file" onChange={handleFrontRc}
                                        className={
                                            vehicleWeightError !== ""
                                                ? "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50 error_class"
                                                : "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                    />
                                    <div>
                                        {isRcFrontImageLoading ? (
                                            <div></div>
                                        ) : (
                                            <img src={rcFrontImage} style={{ height: '100px', width: '100px' }} alt="img" />
                                        )}
                                    </div>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="backRc"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Upload Frontside of your RC*
                                    </label>
                                    <input type="file" onChange={handleBackRc}
                                        className={
                                            vehicleWeightError !== ""
                                                ? "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50 error_class"
                                                : "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                    />
                                    <div>
                                        {isRcBackImageLoading ? (
                                            <div></div>
                                        ) : (
                                            <img src={rcBackImage} style={{ height: '100px', width: '100px' }} alt="img" />
                                        )}
                                    </div>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="airConditioner"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Air Conditioner *
                                    </label>
                                    <select
                                        className={`border-default-200 w-full`}
                                        data-trigger
                                        id="airConditioner"
                                        placeholder="This is a search placeholder"
                                        value={options.id}
                                        name={options.name}
                                        onChange={(e) => selectAirConditionerChange(e)}
                                    >
                                        <option value="0" hidden selected>
                                            Choose Air Conditioner
                                        </option>
                                        {options.map((test, index) => (
                                            <option
                                                key={index}
                                                value={test.id}
                                                name={test.name}
                                                required
                                                selected={test.name === airConditioner}
                                            >
                                                {test.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="cdCharge"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Cd Charge *
                                    </label>
                                    <select
                                        className={`border-default-200 w-full`}
                                        data-trigger
                                        id="cdCharge"
                                        placeholder="This is a search placeholder"
                                        value={options.id}
                                        name={options.name}
                                        onChange={(e) => selectCdChargeChange(e)}
                                    >
                                        <option value="0" hidden selected>
                                            Choose Cd Charge
                                        </option>
                                        {options.map((test, index) => (
                                            <option
                                                key={index}
                                                value={test.id}
                                                name={test.name}
                                                required
                                                selected={test.name === cdCharge}
                                            >
                                                {test.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="seatCover"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Seat Cover *
                                    </label>
                                    <select
                                        className={`border-default-200 w-full`}
                                        data-trigger
                                        id="seatCover"
                                        placeholder="This is a search placeholder"
                                        value={options.id}
                                        name={options.name}
                                        onChange={(e) => selectSeatCoverChange(e)}
                                    >
                                        <option value="0" hidden selected>
                                            Choose Seat Cover
                                        </option>
                                        {options.map((test, index) => (
                                            <option
                                                key={index}
                                                value={test.id}
                                                name={test.name}
                                                required
                                                selected={test.name === seatCover}
                                            >
                                                {test.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="fogLamps"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Fog Lamps *
                                    </label>
                                    <select
                                        className={`border-default-200 w-full`}
                                        data-trigger
                                        id="fogLamps"
                                        placeholder="This is a search placeholder"
                                        value={options.id}
                                        name={options.name}
                                        onChange={(e) => selectFogLampsChange(e)}
                                    >
                                        <option value="0" hidden selected>
                                            Choose Fog Lamps
                                        </option>
                                        {options.map((test, index) => (
                                            <option
                                                key={index}
                                                value={test.id}
                                                name={test.name}
                                                required
                                                selected={test.name === fogLamps}
                                            >
                                                {test.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="transmission"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Transmission *
                                    </label>
                                    <select
                                        className={`border-default-200 w-full`}
                                        data-trigger
                                        id="transmission"
                                        placeholder="This is a search placeholder"
                                        value={Features.id}
                                        name={Features.name}
                                        onChange={(e) => selectTransmissionChange(e)}
                                    >
                                        <option value="0" hidden selected>
                                            Choose Transmission
                                        </option>
                                        {Features.map((test, index) => (
                                            <option
                                                key={index}
                                                value={test.id}
                                                name={test.name}
                                                required
                                                selected={test.name === transmission}
                                            >
                                                {test.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="odometer"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Odometer *
                                    </label>
                                    <select
                                        className={`border-default-200 w-full`}
                                        data-trigger
                                        id="odometer"
                                        placeholder="This is a search placeholder"
                                        value={Features.id}
                                        name={Features.name}
                                        onChange={(e) => selectOdometerChange(e)}
                                    >
                                        <option value="0" hidden selected>
                                            Choose Odometer
                                        </option>
                                        {Features.map((test, index) => (
                                            <option
                                                key={index}
                                                value={test.id}
                                                name={test.name}
                                                required
                                                selected={test.name === odometer}
                                            >
                                                {test.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="accidental"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Accidental *
                                    </label>
                                    <select
                                        className={`border-default-200 w-full`}
                                        data-trigger
                                        id="accidental"
                                        placeholder="This is a search placeholder"
                                        value={options.id}
                                        name={options.name}
                                        onChange={(e) => selectAccidentalChange(e)}
                                    >
                                        <option value="0" hidden selected>
                                            Choose Accidental
                                        </option>
                                        {options.map((test, index) => (
                                            <option
                                                key={index}
                                                value={test.id}
                                                name={test.name}
                                                required
                                                selected={test.name === accidental}
                                            >
                                                {test.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="otherRepair"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Other Repair *
                                    </label>
                                    <select
                                        className={`border-default-200 w-full`}
                                        data-trigger
                                        id="otherRepair"
                                        placeholder="This is a search placeholder"
                                        value={options.id}
                                        name={options.name}
                                        onChange={(e) => selectotherRepairlChange(e)}
                                    >
                                        <option value="0" hidden selected>
                                            Choose Other Repair
                                        </option>
                                        {options.map((test, index) => (
                                            <option
                                                key={index}
                                                value={test.id}
                                                name={test.name}
                                                required
                                                selected={test.name === otherRepair}
                                            >
                                                {test.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="fitnessExpiry"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Fitness Expiry *
                                    </label>
                                    <input
                                        type="Date"
                                        className={
                                            "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                        id="fitnessExpiry"
                                        placeholder="Enter FitnessExpiry"
                                        value={fitnessExpiry}
                                        onChange={(e) => setFitnessExpiry(e.target.value)}
                                    />
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="roadtaxValidity"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Roadtax Validity *
                                    </label>
                                    <input
                                        type="Date"
                                        className={
                                            "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                        id="roadtaxValidity"
                                        placeholder="Enter RoadtaxValidity"
                                        value={roadtaxValidity}
                                        onChange={(e) => setroadtaxValidity(e.target.value)}
                                    />
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="fIdvValue"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Idv Value *
                                    </label>
                                    <input
                                        type="text"
                                        className={
                                            "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                        id="fIdvValue"
                                        placeholder="Enter RoadtaxValidity"
                                        value={idvValue}
                                        onChange={(e) => setIdvValue(e.target.value)}
                                    />
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="fInsuranceExpiry"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Insurance Expiry *
                                    </label>
                                    <input
                                        type="date"
                                        className={
                                            "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                        id="fInsuranceExpiry"
                                        placeholder="Enter Insurance Expiry"
                                        value={insuranceExpiry}
                                        onChange={(e) => setInsuranceExpiry(e.target.value)}
                                    />
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="engineCondition"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Engine Condition <span style={{ color: 'red' }}>**</span>
                                    </label>
                                    <select
                                        className={
                                            engineConditionError === ""
                                                ? `border-default-200 w-full`
                                                : `border-default-200 w-full error_class`
                                        }
                                        data-trigger
                                        id="engineCondition"
                                        placeholder="This is a search placeholder"
                                        value={reqCondition.id}
                                        name={reqCondition.name}
                                        onChange={(e) => selectEngineConditionChange(e)}
                                    >
                                        <option value="0" hidden selected>
                                            Choose Engine Condition
                                        </option>
                                        {reqCondition.map((test, index) => (
                                            <option
                                                key={index}
                                                value={test.id}
                                                name={test.name}
                                                required
                                                selected={test.name === engineCondition}
                                            >
                                                {test.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="wheelType"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Wheel Type *
                                    </label>
                                    <select
                                        className={`border-default-200 w-full`}
                                        data-trigger
                                        id="wheelType"
                                        placeholder="This is a search placeholder"
                                        value={wheelTypeList.id}
                                        name={wheelTypeList.name}
                                        onChange={(e) => selectWheelTypeChange(e)}
                                    >
                                        <option value="0" hidden selected>
                                            Choose Wheel Type
                                        </option>
                                        {wheelTypeList.map((test, index) => (
                                            <option
                                                key={index}
                                                value={test.id}
                                                name={test.name}
                                                required
                                                selected={test.name === wheelType}
                                            >
                                                {test.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                <div className="space-y-1">
                                    <label
                                        htmlFor="fTotalTyre"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Total Tyre *
                                    </label>
                                    <input
                                        type="text"
                                        className={
                                            "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                        id="fTotalTyre"
                                        placeholder="Enter Total Tyre"
                                        value={totalTyre}
                                        onChange={(e) => setTotalTyre(e.target.value)}
                                    />
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="fTotalTyre"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Available Tyre *
                                    </label>
                                    <input
                                        type="text"
                                        className={
                                            "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                        id="fTotalTyre"
                                        placeholder="Enter Available Tyre"
                                        value={availableTyre}
                                        onChange={(e) => setAvailableTyre(e.target.value)}
                                    />
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="fMissingTyre"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Missing Tyre *
                                    </label>
                                    <input
                                        type="text"
                                        className={
                                            "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                        id="fMissingTyre"
                                        placeholder="Enter Missing Tyre"
                                        value={missingTyre}
                                        onChange={(e) => setMissingTyre(e.target.value)}
                                    />
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="fSpareTyre"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Spare Tyre *
                                    </label>
                                    <input
                                        type="text"
                                        className={
                                            "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                        id="fSpareTyre"
                                        placeholder="Enter Spare Tyre"
                                        value={spareTyre}
                                        onChange={(e) => setSpareTyre(e.target.value)}
                                    />
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="interiorCondition"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Interior Condition <span style={{ color: 'red' }}>**</span>
                                    </label>
                                    <select
                                        className={
                                            interiorConditionError === ""
                                                ? `border-default-200 w-full`
                                                : `border-default-200 w-full error_class`
                                        }
                                        data-trigger
                                        id="interiorCondition"
                                        placeholder="This is a search placeholder"
                                        value={reqCondition.id}
                                        name={reqCondition.name}
                                        onChange={(e) => selectInteriorConditionChange(e)}
                                    >
                                        <option value="0" hidden selected>
                                            Choose Interior Condition
                                        </option>
                                        {reqCondition.map((test, index) => (
                                            <option
                                                key={index}
                                                value={test.id}
                                                name={test.name}
                                                required
                                                selected={test.name === interiorCondition}
                                            >
                                                {test.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="exteriorCondition"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Exterior Condition <span style={{ color: 'red' }}>**</span>
                                    </label>
                                    <select
                                        className={
                                            exteriorConditionError === ""
                                                ? `border-default-200 w-full`
                                                : `border-default-200 w-full error_class`
                                        }
                                        data-trigger
                                        id="exteriorCondition"
                                        placeholder="This is a search placeholder"
                                        value={reqCondition.id}
                                        name={reqCondition.name}
                                        onChange={(e) => selectExteriorConditionChange(e)}
                                    >
                                        <option value="0" hidden selected>
                                            Choose Exterior Condition
                                        </option>
                                        {reqCondition.map((test, index) => (
                                            <option
                                                key={index}
                                                value={test.id}
                                                name={test.name}
                                                required
                                                selected={test.name === exteriorCondition}
                                            >
                                                {test.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="headLamp"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Head Lamp *
                                    </label>
                                    <select
                                        className={`border-default-200 w-full`}
                                        data-trigger
                                        id="headLamp"
                                        placeholder="This is a search placeholder"
                                        value={condition.id}
                                        name={condition.name}
                                        onChange={(e) => selectHeadLampChange(e)}
                                    >
                                        <option value="0" hidden selected>
                                            Choose Head Lamp
                                        </option>
                                        {condition.map((test, index) => (
                                            <option
                                                key={index}
                                                value={test.id}
                                                name={test.name}
                                                required
                                                selected={test.name === headLamp}
                                            >
                                                {test.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="tailLamp"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Tail Lamp *
                                    </label>
                                    <select
                                        className={`border-default-200 w-full`}
                                        data-trigger
                                        id="tailLamp"
                                        placeholder="This is a search placeholder"
                                        value={condition.id}
                                        name={condition.name}
                                        onChange={(e) => selectTailLampChange(e)}
                                    >
                                        <option value="0" hidden selected>
                                            Choose Tail Lamp
                                        </option>
                                        {condition.map((test, index) => (
                                            <option
                                                key={index}
                                                value={test.id}
                                                name={test.name}
                                                required
                                                selected={test.name === tailLamp}
                                            >
                                                {test.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="frontIndicators"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Front Indicators *
                                    </label>
                                    <select
                                        className={`border-default-200 w-full`}
                                        data-trigger
                                        id="frontIndicators"
                                        placeholder="This is a search placeholder"
                                        value={condition.id}
                                        name={condition.name}
                                        onChange={(e) => selectFrontIndicatorsChange(e)}
                                    >
                                        <option value="0" hidden selected>
                                            Choose Front Indicators
                                        </option>
                                        {condition.map((test, index) => (
                                            <option
                                                key={index}
                                                value={test.id}
                                                name={test.name}
                                                required
                                                selected={test.name === frontIndicators}
                                            >
                                                {test.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="rearIndicators"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Rear Indicators *
                                    </label>
                                    <select
                                        className={`border-default-200 w-full`}
                                        data-trigger
                                        id="rearIndicators"
                                        placeholder="This is a search placeholder"
                                        value={condition.id}
                                        name={condition.name}
                                        onChange={(e) => selectRearIndicatorsChange(e)}
                                    >
                                        <option value="0" hidden selected>
                                            Choose Rear Indicators
                                        </option>
                                        {condition.map((test, index) => (
                                            <option
                                                key={index}
                                                value={test.id}
                                                name={test.name}
                                                required
                                                selected={test.name === rearIndicators}
                                            >
                                                {test.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="maintenanceLevel"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Maintenance Level *
                                    </label>
                                    <select
                                        className={`border-default-200 w-full`}
                                        data-trigger
                                        id="maintenanceLevel"
                                        placeholder="This is a search placeholder"
                                        value={condition.id}
                                        name={condition.name}
                                        onChange={(e) => selectMaintenanceLevelChange(e)}
                                    >
                                        <option value="0" hidden selected>
                                            Choose Maintenance Level
                                        </option>
                                        {condition.map((test, index) => (
                                            <option
                                                key={index}
                                                value={test.id}
                                                name={test.name}
                                                required
                                                selected={test.name === maintenanceLevel}
                                            >
                                                {test.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="frontBrakeCondition"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        FrontBreak Condition *
                                    </label>
                                    <select
                                        className={
                                            frontBrakeConditionError === ""
                                                ? `border-default-200 w-full`
                                                : `border-default-200 w-full error_class`
                                        }
                                        data-trigger
                                        id="frontBrakeCondition"
                                        placeholder="This is a search placeholder"
                                        value={reqCondition.id}
                                        name={reqCondition.name}
                                        onChange={(e) => selectFrontBreakConditionChange(e)}
                                    >
                                        <option value="0" hidden selected>
                                            Choose FrontBreak Condition <span style={{ color: 'red' }}>**</span>
                                        </option>
                                        {reqCondition.map((test, index) => (
                                            <option
                                                key={index}
                                                value={test.id}
                                                name={test.name}
                                                required
                                                selected={test.name === frontBrakeCondition}
                                            >
                                                {test.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="rearBrakeCondition"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Rear Break Condition <span style={{ color: 'red' }}>**</span>
                                    </label>
                                    <select
                                        className={
                                            rearBrakeConditionError === ""
                                                ? `border-default-200 w-full`
                                                : `border-default-200 w-full error_class`
                                        }
                                        data-trigger
                                        id="rearBrakeCondition"
                                        placeholder="This is a search placeholder"
                                        value={reqCondition.id}
                                        name={reqCondition.name}
                                        onChange={(e) => selectRearBreakConditionChange(e)}
                                    >
                                        <option value="0" hidden selected>
                                            Choose Rear Break Condition
                                        </option>
                                        {reqCondition.map((test, index) => (
                                            <option
                                                key={index}
                                                value={test.id}
                                                name={test.name}
                                                required
                                                selected={test.name === rearBrakeCondition}
                                            >
                                                {test.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="comFrontCrashGuard"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Front CrashGuard *
                                    </label>
                                    <select
                                        className={`border-default-200 w-full`}
                                        data-trigger
                                        id="comFrontCrashGuard"
                                        placeholder="This is a search placeholder"
                                        value={options.id}
                                        name={options.name}
                                        onChange={(e) => selectsetFrontCrashGuardChange(e)}
                                    >
                                        <option value="0" hidden selected>
                                            Choose Front CrashGuard
                                        </option>
                                        {options.map((test, index) => (
                                            <option
                                                key={index}
                                                value={test.id}
                                                name={test.name}
                                                required
                                                selected={test.name === comFrontCrashGuard}
                                            >
                                                {test.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="comLoadCarrier"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Load Carrier *
                                    </label>
                                    <select
                                        className={`border-default-200 w-full`}
                                        data-trigger
                                        id="comLoadCarrier"
                                        placeholder="This is a search placeholder"
                                        value={options.id}
                                        name={options.name}
                                        onChange={(e) => selectComLoadCarrierChange(e)}
                                    >
                                        <option value="0" hidden selected>
                                            Choose Load Carrier
                                        </option>
                                        {options.map((test, index) => (
                                            <option
                                                key={index}
                                                value={test.id}
                                                name={test.name}
                                                required
                                                selected={test.name === comLoadCarrier}
                                            >
                                                {test.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="comMusicSystem"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Music System *
                                    </label>
                                    <select
                                        className={`border-default-200 w-full`}
                                        data-trigger
                                        id="comMusicSystem"
                                        placeholder="This is a search placeholder"
                                        value={options.id}
                                        name={options.name}
                                        onChange={(e) => selectComMusicSystemChange(e)}
                                    >
                                        <option value="0" hidden selected>
                                            Choose Music System
                                        </option>
                                        {options.map((test, index) => (
                                            <option
                                                key={index}
                                                value={test.id}
                                                name={test.name}
                                                required
                                                selected={test.name === comMusicSystem}
                                            >
                                                {test.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="comRearUnderRun"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Rear UnderRun *
                                    </label>
                                    <select
                                        className={`border-default-200 w-full`}
                                        data-trigger
                                        id="comRearUnderRun"
                                        placeholder="This is a search placeholder"
                                        value={options.id}
                                        name={options.name}
                                        onChange={(e) => selectComRearUnderRunChange(e)}
                                    >
                                        <option value="0" hidden selected>
                                            Choose Rear UnderRun
                                        </option>
                                        {options.map((test, index) => (
                                            <option
                                                key={index}
                                                value={test.id}
                                                name={test.name}
                                                required
                                                selected={test.name === comRearUnderRun}
                                            >
                                                {test.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="comSideUnderRun"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Side UnderRun *
                                    </label>
                                    <select
                                        className={`border-default-200 w-full`}
                                        data-trigger
                                        id="comSideUnderRun"
                                        placeholder="This is a search placeholder"
                                        value={options.id}
                                        name={options.name}
                                        onChange={(e) => selectComSideUnderRunChange(e)}
                                    >
                                        <option value="0" hidden selected>
                                            Choose Side UnderRun
                                        </option>
                                        {options.map((test, index) => (
                                            <option
                                                key={index}
                                                value={test.id}
                                                name={test.name}
                                                required
                                                selected={test.name === comSideUnderRun}
                                            >
                                                {test.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="comToolkit"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Toolkit *
                                    </label>
                                    <select
                                        className={`border-default-200 w-full`}
                                        data-trigger
                                        id="comToolkit"
                                        placeholder="This is a search placeholder"
                                        value={options.id}
                                        name={options.name}
                                        onChange={(e) => selectComToolkitChange(e)}
                                    >
                                        <option value="0" hidden selected>
                                            Choose Toolkit
                                        </option>
                                        {options.map((test, index) => (
                                            <option
                                                key={index}
                                                value={test.id}
                                                name={test.name}
                                                required
                                                selected={test.name === comToolkit}
                                            >
                                                {test.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="comTvVideo"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Tv & Video  *
                                    </label>
                                    <select
                                        className={`border-default-200 w-full`}
                                        data-trigger
                                        id="comTvVideo"
                                        placeholder="This is a search placeholder"
                                        value={options.id}
                                        name={options.name}
                                        onChange={(e) => selectComTvVideoChange(e)}
                                    >
                                        <option value="0" hidden selected>
                                            Choose Tv & Video
                                        </option>
                                        {options.map((test, index) => (
                                            <option
                                                key={index}
                                                value={test.id}
                                                name={test.name}
                                                required
                                                selected={test.name === comTvVideo}
                                            >
                                                {test.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                <div className="space-y-1">
                                    <label
                                        htmlFor="comBodyCondition"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Body Condition *
                                    </label>
                                    <select
                                        className={`border-default-200 w-full`}
                                        data-trigger
                                        id="comBodyCondition"
                                        placeholder="This is a search placeholder"
                                        value={condition.id}
                                        name={condition.name}
                                        onChange={(e) => selectComBodyConditionChange(e)}
                                    >
                                        <option value="0" hidden selected>
                                            Choose Body Condition
                                        </option>
                                        {condition.map((test, index) => (
                                            <option
                                                key={index}
                                                value={test.id}
                                                name={test.name}
                                                required
                                                selected={test.name === comBodyCondition}
                                            >
                                                {test.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="comHandBrake"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Hand Brake *
                                    </label>
                                    <select
                                        className={`border-default-200 w-full`}
                                        data-trigger
                                        id="comHandBrake"
                                        placeholder="This is a search placeholder"
                                        value={condition.id}
                                        name={condition.name}
                                        onChange={(e) => selectComHandBrakeChange(e)}
                                    >
                                        <option value="0" hidden selected>
                                            Choose Hand Brake
                                        </option>
                                        {condition.map((test, index) => (
                                            <option
                                                key={index}
                                                value={test.id}
                                                name={test.name}
                                                required
                                                selected={test.name === comHandBrake}
                                            >
                                                {test.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="comDoorCondition"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Door Condition *
                                    </label>
                                    <select
                                        className={`border-default-200 w-full`}
                                        data-trigger
                                        id="comDoorCondition"
                                        placeholder="This is a search placeholder"
                                        value={condition.id}
                                        name={condition.name}
                                        onChange={(e) => selectComDoorConditionChange(e)}
                                    >
                                        <option value="0" hidden selected>
                                            Choose  Door Condition
                                        </option>
                                        {condition.map((test, index) => (
                                            <option
                                                key={index}
                                                value={test.id}
                                                name={test.name}
                                                required
                                                selected={test.name === comDoorCondition}
                                            >
                                                {test.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="comSideGlassesCondition"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Side Glasses Condition *
                                    </label>
                                    <select
                                        className={`border-default-200 w-full`}
                                        data-trigger
                                        id="comSideGlassesCondition"
                                        placeholder="This is a search placeholder"
                                        value={condition.id}
                                        name={condition.name}
                                        onChange={(e) => selectComSideGlassesConditionChange(e)}
                                    >
                                        <option value="0" hidden selected>
                                            Choose  Side Glasses Condition
                                        </option>
                                        {condition.map((test, index) => (
                                            <option
                                                key={index}
                                                value={test.id}
                                                name={test.name}
                                                required
                                                selected={test.name === comSideGlassesCondition}
                                            >
                                                {test.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="comWindscreenCondition"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Wind Screen Condition *
                                    </label>
                                    <select
                                        className={`border-default-200 w-full`}
                                        data-trigger
                                        id="comWindscreenCondition"
                                        placeholder="This is a search placeholder"
                                        value={condition.id}
                                        name={condition.name}
                                        onChange={(e) => selectComWindscreenConditionChange(e)}
                                    >
                                        <option value="0" hidden selected>
                                            Choose Wind Screen Condition
                                        </option>
                                        {condition.map((test, index) => (
                                            <option
                                                key={index}
                                                value={test.id}
                                                name={test.name}
                                                required
                                                selected={test.name === comWindscreenCondition}
                                            >
                                                {test.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="comBatteryCondition"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Battery Condition *
                                    </label>
                                    <select
                                        className={`border-default-200 w-full`}
                                        data-trigger
                                        id="comBatteryCondition"
                                        placeholder="This is a search placeholder"
                                        value={condition.id}
                                        name={condition.name}
                                        onChange={(e) => selectComBatteryConditionChange(e)}
                                    >
                                        <option value="0" hidden selected>
                                            Choose Battery Condition
                                        </option>
                                        {condition.map((test, index) => (
                                            <option
                                                key={index}
                                                value={test.id}
                                                name={test.name}
                                                required
                                                selected={test.name === comBatteryCondition}
                                            >
                                                {test.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="comClusterUnitCondition"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Cluster Unit Condition *
                                    </label>
                                    <select
                                        className={`border-default-200 w-full`}
                                        data-trigger
                                        id="comClusterUnitCondition"
                                        placeholder="This is a search placeholder"
                                        value={condition.id}
                                        name={condition.name}
                                        onChange={(e) => selectComClusterUnitConditionChange(e)}
                                    >
                                        <option value="0" hidden selected>
                                            Choose  Cluster Unit Condition
                                        </option>
                                        {condition.map((test, index) => (
                                            <option
                                                key={index}
                                                value={test.id}
                                                name={test.name}
                                                required
                                                selected={test.name === comClusterUnitCondition}
                                            >
                                                {test.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="comFogLampStatus"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        FogLamp Status *
                                    </label>
                                    <select
                                        className={`border-default-200 w-full`}
                                        data-trigger
                                        id="comFogLampStatus"
                                        placeholder="This is a search placeholder"
                                        value={options.id}
                                        name={options.name}
                                        onChange={(e) => selectComFogLampStatusChange(e)}
                                    >
                                        <option value="0" hidden selected>
                                            Choose  FogLamp Status
                                        </option>
                                        {options.map((test, index) => (
                                            <option
                                                key={index}
                                                value={test.id}
                                                name={test.name}
                                                required
                                                selected={test.name === comFogLampStatus}
                                            >
                                                {test.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                <div className="space-y-1">
                                    <label
                                        htmlFor="fBatteryNo"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Battery No *
                                    </label>
                                    <input
                                        type="text"
                                        className={
                                            "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                        id="fBatteryNo"
                                        placeholder="Enter Battery No"
                                        value={comBatteryNo}
                                        onChange={(e) => setComBatteryNo(e.target.value)}
                                    />
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="comWiperStatus"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Wiper Status *
                                    </label>
                                    <select
                                        className={`border-default-200 w-full`}
                                        data-trigger
                                        id="comWiperStatus"
                                        placeholder="This is a search placeholder"
                                        value={options.id}
                                        name={options.name}
                                        onChange={(e) => selectComWiperStatusChange(e)}
                                    >
                                        <option value="0" hidden selected>
                                            Choose  Wiper Status
                                        </option>
                                        {options.map((test, index) => (
                                            <option
                                                key={index}
                                                value={test.id}
                                                name={test.name}
                                                required
                                                selected={test.name === comWiperStatus}
                                            >
                                                {test.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="comEngineStatus"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Engine Status *
                                    </label>
                                    <select
                                        className={`border-default-200 w-full`}
                                        data-trigger
                                        id="comEngineStatus"
                                        placeholder="This is a search placeholder"
                                        value={options.id}
                                        name={options.name}
                                        onChange={(e) => selectComEngineStatusChange(e)}
                                    >
                                        <option value="0" hidden selected>
                                            Choose  Engine Status
                                        </option>
                                        {options.map((test, index) => (
                                            <option
                                                key={index}
                                                value={test.id}
                                                name={test.name}
                                                required
                                                selected={test.name === comEngineStatus}
                                            >
                                                {test.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="comEngineShieldCondition"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Engine Shield Condition *
                                    </label>
                                    <select
                                        className={`border-default-200 w-full`}
                                        data-trigger
                                        id="comEngineShieldCondition"
                                        placeholder="This is a search placeholder"
                                        value={condition.id}
                                        name={condition.name}
                                        onChange={(e) => selectComEngineShieldConditionChange(e)}
                                    >
                                        <option value="0" hidden selected>
                                            Choose Engine Shield Condition
                                        </option>
                                        {condition.map((test, index) => (
                                            <option
                                                key={index}
                                                value={test.id}
                                                name={test.name}
                                                required
                                                selected={test.name === comEngineShieldCondition}
                                            >
                                                {test.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="comFluidLeakStatus"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Fluid Leak Status *
                                    </label>
                                    <select
                                        className={`border-default-200 w-full`}
                                        data-trigger
                                        id="comFluidLeakStatus"
                                        placeholder="This is a search placeholder"
                                        value={options.id}
                                        name={options.name}
                                        onChange={(e) => selectComFluidLeakStatusChange(e)}
                                    >
                                        <option value="0" hidden selected>
                                            Choose Fluid Leak Status
                                        </option>
                                        {options.map((test, index) => (
                                            <option
                                                key={index}
                                                value={test.id}
                                                name={test.name}
                                                required
                                                selected={test.name === comFluidLeakStatus}
                                            >
                                                {test.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="comSuspensionCondition"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Suspension Condition <span style={{ color: 'red' }}>**</span>
                                    </label>
                                    <select
                                        className={
                                            comSuspensionConditionError === ""
                                                ? `border-default-200 w-full`
                                                : `border-default-200 w-full error_class`
                                        }
                                        data-trigger
                                        id="comSuspensionCondition"
                                        placeholder="This is a search placeholder"
                                        value={reqCondition.id}
                                        name={reqCondition.name}
                                        onChange={(e) => selectComSuspensionConditionChange(e)}
                                    >
                                        <option value="0" hidden selected>
                                            Choose Suspension Condition
                                        </option>
                                        {reqCondition.map((test, index) => (
                                            <option
                                                key={index}
                                                value={test.id}
                                                name={test.name}
                                                required
                                                selected={test.name === comSuspensionCondition}
                                            >
                                                {test.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="comTransmissionCondition"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Transmission Condition <span style={{ color: 'red' }}>**</span>
                                    </label>
                                    <select
                                        className={
                                            comTransmissionConditionError === ""
                                                ? `border-default-200 w-full`
                                                : `border-default-200 w-full error_class`
                                        }
                                        data-trigger
                                        id="comTransmissionCondition"
                                        placeholder="This is a search placeholder"
                                        value={reqCondition.id}
                                        name={reqCondition.name}
                                        onChange={(e) => selectComTransmissionConditionChange(e)}
                                    >
                                        <option value="0" hidden selected>
                                            Choose Transmission Condition
                                        </option>
                                        {reqCondition.map((test, index) => (
                                            <option
                                                key={index}
                                                value={test.id}
                                                name={test.name}
                                                required
                                                selected={test.name === comTransmissionCondition}
                                            >
                                                {test.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                <div className="space-y-1">
                                    <label
                                        htmlFor="comAxleOneLeftIn"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Axle OneLeft In  *
                                    </label>
                                    <select
                                        className={`border-default-200 w-full`}
                                        data-trigger
                                        id="comAxleOneLeftIn"
                                        placeholder="This is a search placeholder"
                                        value={list.id}
                                        name={list.name}
                                        onChange={(e) => selectComAxleOneLeftInChange(e)}
                                    >
                                        <option value="0" hidden selected>
                                            Choose Axle OneLeft In
                                        </option>
                                        {list.map((test, index) => (
                                            <option
                                                key={index}
                                                value={test.id}
                                                name={test.name}
                                                required
                                                selected={test.name === comAxleOneLeftIn}
                                            >
                                                {test.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="comAxleOneLeftOut"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Axle OneLeft Out  *
                                    </label>
                                    <select
                                        className={`border-default-200 w-full`}
                                        data-trigger
                                        id="comAxleOneLeftOut"
                                        placeholder="This is a search placeholder"
                                        value={list.id}
                                        name={list.name}
                                        onChange={(e) => selectComAxleOneLeftOutChange(e)}
                                    >
                                        <option value="0" hidden selected>
                                            Choose Axle OneLeft Out
                                        </option>
                                        {list.map((test, index) => (
                                            <option
                                                key={index}
                                                value={test.id}
                                                name={test.name}
                                                required
                                                selected={test.name === comAxleOneLeftOut}
                                            >
                                                {test.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="comAxleOneRightIn"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Axle OneRight In  *
                                    </label>
                                    <select
                                        className={`border-default-200 w-full`}
                                        data-trigger
                                        id="comAxleOneRightIn"
                                        placeholder="This is a search placeholder"
                                        value={list.id}
                                        name={list.name}
                                        onChange={(e) => selectComAxleOneRightInChange(e)}
                                    >
                                        <option value="0" hidden selected>
                                            Choose Axle OneRight In
                                        </option>
                                        {list.map((test, index) => (
                                            <option
                                                key={index}
                                                value={test.id}
                                                name={test.name}
                                                required
                                                selected={test.name === comAxleOneRightIn}
                                            >
                                                {test.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="comAxleOneRightOut"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Axle OneRight Out  *
                                    </label>
                                    <select
                                        className={`border-default-200 w-full`}
                                        data-trigger
                                        id="comAxleOneRightOut"
                                        placeholder="This is a search placeholder"
                                        value={list.id}
                                        name={list.name}
                                        onChange={(e) => selectComAxleOneRightOutChange(e)}
                                    >
                                        <option value="0" hidden selected>
                                            Choose Axle OneRight Out
                                        </option>
                                        {list.map((test, index) => (
                                            <option
                                                key={index}
                                                value={test.id}
                                                name={test.name}
                                                required
                                                selected={test.name === comAxleOneRightOut}
                                            >
                                                {test.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="comAxleThreeLeftIn"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Axle ThreeLeft In  *
                                    </label>
                                    <select
                                        className={`border-default-200 w-full`}
                                        data-trigger
                                        id="comAxleThreeLeftIn"
                                        placeholder="This is a search placeholder"
                                        value={list.id}
                                        name={list.name}
                                        onChange={(e) => selectComAxleThreeLeftInChange(e)}
                                    >
                                        <option value="0" hidden selected>
                                            Choose Axle ThreeLeft In
                                        </option>
                                        {list.map((test, index) => (
                                            <option
                                                key={index}
                                                value={test.id}
                                                name={test.name}
                                                required
                                                selected={test.name === comAxleThreeLeftIn}
                                            >
                                                {test.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="comAxleThreeLeftOut"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Axle ThreeLeft Out  *
                                    </label>
                                    <select
                                        className={`border-default-200 w-full`}
                                        data-trigger
                                        id="comAxleThreeLeftOut"
                                        placeholder="This is a search placeholder"
                                        value={list.id}
                                        name={list.name}
                                        onChange={(e) => selectComAxleThreeLeftOutChange(e)}
                                    >
                                        <option value="0" hidden selected>
                                            Choose Axle ThreeLeft Out
                                        </option>
                                        {list.map((test, index) => (
                                            <option
                                                key={index}
                                                value={test.id}
                                                name={test.name}
                                                required
                                                selected={test.name === comAxleThreeLeftOut}
                                            >
                                                {test.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="comAxleThreeRightIn"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Axle ThreeRight In  *
                                    </label>
                                    <select
                                        className={`border-default-200 w-full`}
                                        data-trigger
                                        id="comAxleThreeRightIn"
                                        placeholder="This is a search placeholder"
                                        value={list.id}
                                        name={list.name}
                                        onChange={(e) => selectComAxleThreeRightInChange(e)}
                                    >
                                        <option value="0" hidden selected>
                                            Choose Axle ThreeRight In
                                        </option>
                                        {list.map((test, index) => (
                                            <option
                                                key={index}
                                                value={test.id}
                                                name={test.name}
                                                required
                                                selected={test.name === comAxleThreeRightIn}
                                            >
                                                {test.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="comAxleThreeRightOut"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Axle ThreeRight Out  *
                                    </label>
                                    <select
                                        className={`border-default-200 w-full`}
                                        data-trigger
                                        id="comAxleThreeRightOut"
                                        placeholder="This is a search placeholder"
                                        value={list.id}
                                        name={list.name}
                                        onChange={(e) => selectComAxleThreeRightOutChange(e)}
                                    >
                                        <option value="0" hidden selected>
                                            Choose Axle ThreeRight Out
                                        </option>
                                        {list.map((test, index) => (
                                            <option
                                                key={index}
                                                value={test.id}
                                                name={test.name}
                                                required
                                                selected={test.name === comAxleThreeRightOut}
                                            >
                                                {test.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="comAxleTwoLeftIn"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Axle TwoLeft In  *
                                    </label>
                                    <select
                                        className={`border-default-200 w-full`}
                                        data-trigger
                                        id="comAxleTwoLeftIn"
                                        placeholder="This is a search placeholder"
                                        value={list.id}
                                        name={list.name}
                                        onChange={(e) => selectComAxleTwoLeftInChange(e)}
                                    >
                                        <option value="0" hidden selected>
                                            Choose Axle TwoLeft In
                                        </option>
                                        {list.map((test, index) => (
                                            <option
                                                key={index}
                                                value={test.id}
                                                name={test.name}
                                                required
                                                selected={test.name === comAxleTwoLeftIn}
                                            >
                                                {test.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="comAxleTwoLeftOut"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Axle TwoLeft Out  *
                                    </label>
                                    <select
                                        className={`border-default-200 w-full`}
                                        data-trigger
                                        id="comAxleTwoLeftOut"
                                        placeholder="This is a search placeholder"
                                        value={list.id}
                                        name={list.name}
                                        onChange={(e) => selectComAxleTwoLeftOutChange(e)}
                                    >
                                        <option value="0" hidden selected>
                                            Choose Axle TwoLeft Out
                                        </option>
                                        {list.map((test, index) => (
                                            <option
                                                key={index}
                                                value={test.id}
                                                name={test.name}
                                                required
                                                selected={test.name === comAxleTwoLeftOut}
                                            >
                                                {test.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="comAxleTwoRightIn"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Axle TwoRight In  *
                                    </label>
                                    <select
                                        className={`border-default-200 w-full`}
                                        data-trigger
                                        id="comAxleTwoRightIn"
                                        placeholder="This is a search placeholder"
                                        value={list.id}
                                        name={list.name}
                                        onChange={(e) => selectComAxleTwoRightInChange(e)}
                                    >
                                        <option value="0" hidden selected>
                                            Choose Axle TwoRight In
                                        </option>
                                        {list.map((test, index) => (
                                            <option
                                                key={index}
                                                value={test.id}
                                                name={test.name}
                                                required
                                                selected={test.name === comAxleTwoRightIn}
                                            >
                                                {test.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="comAxleTwoRightOut"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Axle TwoRight Out  *
                                    </label>
                                    <select
                                        className={`border-default-200 w-full`}
                                        data-trigger
                                        id="comAxleTwoRightOut"
                                        placeholder="This is a search placeholder"
                                        value={list.id}
                                        name={list.name}
                                        onChange={(e) => selectComAxleTwoRightOutChange(e)}
                                    >
                                        <option value="0" hidden selected>
                                            Choose Axle TwoRight Out
                                        </option>
                                        {list.map((test, index) => (
                                            <option
                                                key={index}
                                                value={test.id}
                                                name={test.name}
                                                required
                                                selected={test.name === comAxleTwoRightOut}
                                            >
                                                {test.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="comFrontOneLeft"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Front OneLeft  *
                                    </label>
                                    <select
                                        className={`border-default-200 w-full`}
                                        data-trigger
                                        id="comFrontOneLeft"
                                        placeholder="This is a search placeholder"
                                        value={list.id}
                                        name={list.name}
                                        onChange={(e) => selectComFrontOneLeftChange(e)}
                                    >
                                        <option value="0" hidden selected>
                                            Choose Front OneLeft
                                        </option>
                                        {list.map((test, index) => (
                                            <option
                                                key={index}
                                                value={test.id}
                                                name={test.name}
                                                required
                                                selected={test.name === comFrontOneLeft}
                                            >
                                                {test.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="comFrontOneRight"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Front OneRight  *
                                    </label>
                                    <select
                                        className={`border-default-200 w-full`}
                                        data-trigger
                                        id="comFrontOneRight"
                                        placeholder="This is a search placeholder"
                                        value={list.id}
                                        name={list.name}
                                        onChange={(e) => selectComFrontOneRightChange(e)}
                                    >
                                        <option value="0" hidden selected>
                                            Choose Front OneRight
                                        </option>
                                        {list.map((test, index) => (
                                            <option
                                                key={index}
                                                value={test.id}
                                                name={test.name}
                                                required
                                                selected={test.name === comFrontOneRight}
                                            >
                                                {test.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="comFrontTwoLeft"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Front TwoLeft  *
                                    </label>
                                    <select
                                        className={`border-default-200 w-full`}
                                        data-trigger
                                        id="comFrontTwoLeft"
                                        placeholder="This is a search placeholder"
                                        value={list.id}
                                        name={list.name}
                                        onChange={(e) => selectComFrontTwoLeftChange(e)}
                                    >
                                        <option value="0" hidden selected>
                                            Choose Front TwoLeft
                                        </option>
                                        {list.map((test, index) => (
                                            <option
                                                key={index}
                                                value={test.id}
                                                name={test.name}
                                                required
                                                selected={test.name === comFrontTwoLeft}
                                            >
                                                {test.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="comFrontTwoRight"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Front TwoRight  *
                                    </label>
                                    <select
                                        className={`border-default-200 w-full`}
                                        data-trigger
                                        id="comFrontTwoRight"
                                        placeholder="This is a search placeholder"
                                        value={list.id}
                                        name={list.name}
                                        onChange={(e) => selectComFrontTwoRightChange(e)}
                                    >
                                        <option value="0" hidden selected>
                                            Choose Front TwoRight
                                        </option>
                                        {list.map((test, index) => (
                                            <option
                                                key={index}
                                                value={test.id}
                                                name={test.name}
                                                required
                                                selected={test.name === comFrontTwoRight}
                                            >
                                                {test.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="comFrontTruckTyreCondition"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Front TruckTyre Condition  <span style={{ color: 'red' }}>**</span>
                                    </label>
                                    <select
                                        className={
                                            comFrontTruckTyreConditionError === ""
                                                ? `border-default-200 w-full`
                                                : `border-default-200 w-full error_class`
                                        }
                                        data-trigger
                                        id="comFrontTruckTyreCondition"
                                        placeholder="This is a search placeholder"
                                        value={reqCondition.id}
                                        name={reqCondition.name}
                                        onChange={(e) => selectComFrontTruckTyreConditionChange(e)}
                                    >
                                        <option value="0" hidden selected>
                                            Choose Front TruckTyre Condition
                                        </option>
                                        {reqCondition.map((test, index) => (
                                            <option
                                                key={index}
                                                value={test.id}
                                                name={test.name}
                                                required
                                                selected={test.name === comFrontTruckTyreCondition}
                                            >
                                                {test.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="comFrontTruckTyreType"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Front TruckTyre Type  *
                                    </label>
                                    <input
                                        type="text"
                                        className={
                                            "block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50"
                                        }
                                        id="fitnessExpiry"
                                        placeholder="Enter Tyre Type"
                                        value={comFrontTruckTyreType}
                                        onChange={(e) => setComFrontTruckTyreType(e.target.value)}
                                    />
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="comAxleCondition"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Axle Condition  *
                                    </label>
                                    <select
                                        className={`border-default-200 w-full`}
                                        data-trigger
                                        id="comAxleCondition"
                                        placeholder="This is a search placeholder"
                                        value={condition.id}
                                        name={condition.name}
                                        onChange={(e) => selectComAxleConditionChange(e)}
                                    >
                                        <option value="0" hidden selected>
                                            Choose Axle Condition
                                        </option>
                                        {condition.map((test, index) => (
                                            <option
                                                key={index}
                                                value={test.id}
                                                name={test.name}
                                                required
                                                selected={test.name === comAxleCondition}
                                            >
                                                {test.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                <div className="space-y-1">
                                    <label
                                        htmlFor="yourRemark"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Your Remark On Vehicle *
                                    </label>
                                    <select
                                        className={`border-default-200 w-full`}
                                        data-trigger
                                        id="yourRemark"
                                        placeholder="This is a search placeholder"
                                        value={condition.id}
                                        name={condition.name}
                                        onChange={(e) => selectYourRemarkChange(e)}
                                    >
                                        <option value="0" hidden selected>
                                            Choose Your Remark On Vehicle
                                        </option>
                                        {condition.map((test, index) => (
                                            <option
                                                key={index}
                                                value={test.id}
                                                name={test.name}
                                                required
                                                selected={test.name === yourRemark}
                                            >
                                                {test.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="fExShowRoomPrice"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Ex-ShowRoom Price <span style={{ color: 'red' }}>**</span>
                                    </label>
                                    <input
                                        type="text"
                                        className={
                                            exShowRoomPriceError === ""
                                                ? `block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50`
                                                : `block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50 error_class`
                                        }
                                        id="fExShowRoomPrice"
                                        placeholder="Enter Ex-ShowRoom Price"
                                        value={exShowRoomPrice}
                                        onChange={(e) => setExShowRoomPrice(e.target.value)}
                                    />
                                </div>
                                <div className="space-y-1">
                                    <label
                                        htmlFor="fEstimatedPrice"
                                        className="text-sm font-medium text-default-900"
                                    >
                                        Estimated Price <span style={{ color: 'red' }}>**</span>
                                    </label>
                                    <input
                                        type="text"
                                        className={
                                            estimatedPriceError === ""
                                                ? `block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50`
                                                : `block w-full rounded py-2.5 px-4 text-default-800 text-sm focus:ring-transparent border-default-200 dark:bg-default-50 error_class`
                                        }
                                        id="fEstimatedPrice"
                                        placeholder="Enter Estimated Price"
                                        value={estimatedPrice}
                                        onChange={(e) => setEstimatedPrice(e.target.value)}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="flex items-center gap-2 justify-end" style={{ marginBottom: '60px' }}>
                        <button
                            onClick={(e) => cancelClick(e)}
                            className="py-2 px-5 inline-flex items-center justify-center gap-2 font-semibold tracking-wide border border-transparent align-middle duration-500 text-sm text-center text-red-600 hover:border-red-500/20 hover:bg-red-500/20 rounded transition-all"
                            style={{ outline: 'none' }}
                        >
                            <i className="ph-bold ph-x text-lg" /> cancel
                        </button>
                        <button
                            className="py-2 px-5 inline-flex items-center justify-center gap-2 font-semibold tracking-wide border align-middle duration-500 text-sm text-center bg-default-800 hover:bg-default-950  text-default-50 rounded"
                            onClick={(e) => handlesubmit(e)}
                            style={{ background: "#d93c92", outline: 'none', border: 'none' }}
                        >
                            <i className="ph-duotone ph-cloud-arrow-up text-lg" />
                            Submit
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AddCommercialCase;
